export default {
    "id": "መታወቂያ",
    "dashboard": "ዳሽቦርድ",
    "warning": "ማስጠንቀቂያ",
    "users": "ተጠቃሚዎች",
    "farms": "እርሻዎች",
    "animals": "እንስሳት",
    "action": "ድርጊት",
    "actionList": "የድርጊት ዝርዝር",
    "drugInventory": "የመድሃኒት ክምችት",
    "inseminatorStatistics": "ኢንሴሚናተር ስታቲስቲክስ",
    "organizationNTR": "ድርጅት NTR",
    "genotypePerformance": "Genotype አፈጻጸም",
    "semenAutomation": "የዘር አውቶማቲክ",
    "activityLogs": "የእንቅስቃሴ ምዝግብ ማስታወሻ",
    "username": "የተጠቃሚ ስም",
    "title": "ርዕስ",
    "deactivated": "ቦዝኗል",
    "name": "ስም",
    "email": "ኢሜይል",
    "emailAddress": "የ ኢሜል አድራሻ",
    "mobileNum": "ስልክ ቁጥር",
    "emailOrMobile": "ኢሜል/ሞባይል",
    "role": "ሚና",
    "roles": "ሚናዎች",
    "department": "መምሪያ",
    "status": "ሁኔታ",
    "pages": "ገፆች",
    "departments": "መምሪያዎች",
    "password": "የይለፍ ቃል",
    "cancel": "ሰርዝ",
    "submit": "አስገባ",
    "error": "ስህተት",
    "success": "ስኬት",
    "Browse": "አስስ",
    "orDropYourFileCsvXlsXlsxHere": "ወይም ፋይልዎን (CSV, XLS, XLSx) እዚህ ይጣሉት",
    "search": "ፈልግ",
    "apply": "ያመልክቱ",
    "select": "ይምረጡ",
    "previous": "ቀዳሚ",
    "mandatory": "የግዴታ",
    "dropYourFileHere": "ወይም ፋይልዎን (CSV, XLS, XLSx, PDF, Docx, PNG,JPEG) እዚህ ይጣሉት",
    "restoreDefault": "ነባሪ እነበረበት መልስ",
    "pending": "በመጠባበቅ ላይ",
    "completed": "ተጠናቀቀ",
    "remove": "አስወግድ",
    "update": "አዘምን",
    "removeFile": "ፋይል አስወግድ",
    "uploadFile": "ፋይል ስቀል",
    "pleaseChoosePreferedLanguage": "እባክዎ የመረጡትን ቋንቋ ይምረጡ",
    "edit": "አርትዕ",
    "activate": "አግብር",
    "deactivate": "አቦዝን",
    "recievedOrders": "የተቀበሉት ትዕዛዞች",
    "chartRepresentation": "የገበታ ውክልና",
    "nameIsRequired": "ስም ያስፈልጋል",
    "export": "ወደ ውጪ ላክ",
    "noFilesAvailable": "ምንም ፋይሎች የሉም",
    "selectDepartmentToshowRoles": "ሚናዎችን ለማሳየት ክፍል ይምረጡ",
    "selectDepartmentWithActiveRoles": "ንቁ ሚና ያለው ክፍል ይምረጡ",
    "nameCanContainOnlyAlphabets": "ስም ፊደሎችን ብቻ ሊይዝ ይችላል።",
    "nameMustBeLessThan15Chars": "ስም ከ30 ቁምፊዎች ያነሰ መሆን አለበት።",
    "emailRequired": "ኢሜል ያስፈልጋል",
    "invalidEmailFormat": "ልክ ያልሆነ የኢሜይል ቅርጸት",
    "mobNumReq": "የሞባይል ቁጥር ያስፈልጋል",
    "invalidMobFormat": "ልክ ያልሆነ የሞባይል ቁጥር ቅርጸት።",
    "passwordRequired": "የይለፍ ቃል ያስፈልጋል",
    "departmentReq": "ክፍል ያስፈልጋል",
    "roleReq": "ሚና ያስፈልጋል",
    "unableToUpdate": "ማዘመን አልተቻለም",
    "orignalName": "የመጀመሪያ ስም",
    "uploadedDate": "የተሰቀለበት ቀን",
    "fileName": "የመዝገብ ስም",
    "importNum": "የማስመጣት ቁጥር",
    "languagePreferences": "የቋንቋ ምርጫ",
    "pleaseTryAgainAfterSometime": "እባክዎ ከተወሰነ ጊዜ በኋላ ይሞክሩ",
    "noChanges": "ምንም ለውጦች የሉም",
    "nothingchanged": "ምንም አልተለወጠም።",
    "pleaseChooseAnImageFile": "እባክዎ የምስል ፋይል ይምረጡ",
    "fileIsTooBigSelectUnder1MB": "ፋይልህ በጣም ትልቅ ነው! ",
    "phoneShouldHave10Chars": "ስልኩ 10 ቁምፊዎች ሊኖሩት ይገባል",
    "onlyCSVAllowed": "የCSV ፋይል ብቻ ነው የሚፈቀደው።",
    "loadingPleaseWait": "በመጫን ላይ... እባክዎ ይጠብቁ",
    "manager": "አስተዳዳሪ",
    "administrator": "አስተዳዳሪ",
    "Comingsoon": "በቅርብ ቀን",
    "totalAnimals": "ጠቅላላ እንስሳት",
    "receivedOrders": "የተቀበሉት ትዕዛዞች",
    "drugs": "መድሃኒቶች",
    "detailedAnalysis": "ዝርዝር ትንታኔ",
    "barGraphRepOfActiveUsersAndDeactivateUsers": "የአሞሌ ግራፍ ንቁ ተጠቃሚዎች እና የቦዘኑ ተጠቃሚዎች ውክልና",
    "barGraphRepOfRegAnimalsVsFarm": "ባር ግራፍ የተመዘገቡ እንስሳት Vs እርሻ ውክልና",
    "roleNumber": "የሚና ቁጥር",
    "roleName": "የሚና ስም",
    "active": "ንቁ",
    "inactive": "ንቁ ያልሆነ",
    "admin": "አስተዳዳሪ",
    "addRole": "ሚና ጨምር",
    "addRoles": "ሚናዎችን ያክሉ",
    "permissions": "ፈቃዶች",
    "sr": "ሲ",
    "moduleName": "የሞዱል ስም",
    "view": "ይመልከቱ",
    "deptNo": "መምሪያ ቁጥር.",
    "selectByCategory": "በምድብ ይምረጡ",
    "weeklyAnalytics": "ሳምንታዊ ትንታኔ",
    "pregnancy": "እርግዝና",
    "analytics": "ትንታኔ",
    "calendar": "የቀን መቁጠሪያ",
    "productName": "የምርት ስም",
    "volumeSold": "የተሸጠ መጠን",
    "recordPoints": "የመመዝገቢያ ነጥቦች",
    "inStock": "ለሽያጭ የቀረበ እቃ",
    "revenue": "ገቢ",
    "stockStatus": "የአክሲዮን ሁኔታ",
    "barChart": "የአሞሌ ገበታ",
    "lineChart": "የመስመር ገበታ",
    "indexReturns": "ማውጫ ተመላሾች",
    "chart": "ገበታ",
    "time": "ጊዜ",
    "production": "ማምረት",
    "customization": "ማበጀት",
    "recordsPerPage": "መዝገቦች በገጽ",
    "noDataAvailable": "ምንም ውሂብ የለም",
    "reporting": "ሪፖርት ማድረግ",
    "optional": "አማራጭ",
    "note": "ማስታወሻ",
    "notes": "ማስታወሻዎች",
    "date": "ቀን",
    "kG": "ኪግ",
    "weight": "ክብደት",
    "type": "ዓይነት",
    "lessthan3Month": "<3 ወር",
    "lessthan6Month": "<6 ወር",
    "lessthan7Month": "<7 ወር",
    "lastWeek": "ባለፈው ሳምንት",
    "thisWeek": "በዚህ ሳምንት",
    "lessthanOneYear": "<1 ዓመታት",
    "lessthanTwoYear": "<2 ዓመታት",
    "lessthanThreeYear": "<3 ዓመታት",
    "lessthanFourYear": "<4 ዓመታት",
    "yes": "አዎ",
    "no": "አይ",
    "of": "የ",
    "notSpecified": "አልተገለጸም።",
    "days": "ቀናት",
    "day": "ቀን",
    "aDay": "አንድ ቀን",
    "years": "ዓመታት",
    "year": "አመት",
    "unit": "ክፍል",
    "units": "ክፍሎች",
    "to": "ወደ",
    "profile": "መገለጫ",
    "logOut": "ውጣ",
    "Unit": "ክፍል",
    "otherSettings": "ሌሎች ቅንብሮች",
    "somethingWentWrong": "የሆነ ስህተት ተከስቷል.",
    "toDo": "ለመስራት",
    "loadingData": "ውሂብ በመጫን ላይ...",
    "taskNumber": "የተግባር ቁጥር",
    "taskName": "የተግባር ስም",
    "startDate": "የመጀመሪያ ቀን",
    "dueDate": "የመጨረሻ ማስረከቢያ ቀን",
    "reason": "ምክንያት",
    "quantity": "ብዛት",
    "cost": "ወጪ",
    "noRecordFound": "ምንም መዝገብ አልተገኘም።",
    "dailyUpdates": "ዕለታዊ ዝመናዎች",
    "weeklyUpdates": "ሳምንታዊ ዝመናዎች",
    "moduleAccessed": "ሞጁል ደርሷል",
    "typesOfAccess": "የመዳረሻ ዓይነቶች",
    "userId": "የተጠቃሚው መለያ",
    "lastLogin": "የመጨረሻ መግቢያ",
    "terminalID": "የተርሚናል መታወቂያ",
    "geographicalAccessPoint": "ጂኦግራፊያዊ የመዳረሻ ነጥብ",
    "iPAddress": "የአይፒ አድራሻ",
    "fileAccessed": "ፋይል ደርሷል",
    "functionAccessed": "ተግባር ገብቷል።",
    "webPageURL": "የድረ-ገጽ URL",
    "accessType": "የመዳረሻ አይነት",
    "unsuccessfulLoginAttempts": "ያልተሳኩ የመግባት ሙከራዎች",
    "customerAddress": "የደንበኛ አድራሻ",
    "orderdate": "የታዘዘበት ቀን",
    "postageDate": "የፖስታ ቀን",
    "postID": "የፖስታ መታወቂያ",
    "packingTechnician": "የማሸጊያ ቴክኒሻን",
    "packingTechnicia": "ማሸግ ቴክኒሻ",
    "packEdit": "ማሸግ አርትዕ",
    "batchNumber": "ባች ቁጥር",
    "collectionTechnician": "የስብስብ ቴክኒሻን",
    "collectionTechnicia": "ስብስብ Technicia",
    "preparationTechnicia": "የዝግጅት ቴክኒሻን",
    "preparationTechnician": "የዝግጅት ቴክኒሻን",
    "approvedManually": "በእጅ ጸድቋል",
    "researcher": "ተመራማሪ",
    "dateOfApproval": "የተፈቀደበት ቀን",
    "approvalEdit": "ማጽደቅ አርትዕ",
    "searchByAllExceptDate": "ከቀን በስተቀር በሁሉም ፈልግ",
    "approval": "ማጽደቅ",
    "collection": "ስብስብ",
    "postage": "ፖስታ",
    "pack": "እሽግ",
    "straws": "ገለባ",
    "createdAt": "የተፈጠረው በ",
    "sireID": "የሲር መታወቂያ",
    "economicIndexValue": "የኢኮኖሚ ኢንዴክስ ዋጋ",
    "latestCollectionDate": "የቅርብ ጊዜ የስብስብ ቀን",
    "locationId": "የአካባቢ መታወቂያ",
    "lastUpdated": "መጨረሻ የተሻሻለው",
    "print": "አትም",
    "save": "አስቀምጥ",
    "tax": "ግብር",
    "phoneNo": "ስልክ ቁጥር",
    "exportAsPDF": "እንደ ፒዲኤፍ ወደ ውጪ ላክ",
    "statusUpdated": "ሁኔታ ተዘምኗል",
    "statusNotUpdated": "ሁኔታ አልዘመነም።",
    "inProgress": "በሂደት ላይ",
    "assignedTo": "የተመደበው ለ",
    "taskId": "የተግባር መታወቂያ",
    "createdDate": "የተፈጠረበት ቀን",
    "numberOfAnimals": "የእንስሳት ብዛት",
    "healthRecordSubmittedSuccess": "የጤና መዝገብ በተሳካ ሁኔታ ገብቷል።",
    "healthRecordSubmitted": "የጤና መዝገብ ገብቷል።",
    "InseminationRecordSubmittedSuccesful": "የማዳቀል መዝገብ በተሳካ ሁኔታ ገብቷል።",
    "inseminationRecordSubmitted": "የማዳቀል መዝገብ ገብቷል።",
    "actionListDailyTask": "የድርጊት ዝርዝር - ዕለታዊ ተግባር",
    "sinceLastYear": "ካለፈው ዓመት ጀምሮ",
    "sinceLastQuarter": "ካለፈው ሩብ ዓመት ጀምሮ",
    "sinceLastMonth": "ካለፈው ወር ጀምሮ",
    "sinceLastWeek": "ካለፈው ሳምንት ጀምሮ",
    "drugWithdrawPeriod": "የመድኃኒት ማውጣት ጊዜ",
    "diagnosisName": "የምርመራ ስም",
    "animalWithNoGenetype": "ይህ እንስሳ ምንም የተመዘገበ የGenotype ውሂብ የለውም። ",
    "nameOfPreviousOwner": "የቀድሞ ባለቤት ስም",
    "avatarSize": "የአቫታር መጠን ከ 1 ሜባ ያነሰ መሆን አለበት!",
    "testDestination": "የሙከራ መድረሻ",
    "animalNotAdded": "እንስሳ አልተጨመረም።",
    "registerationSuccessful": "ምዝገባው ተሳክቷል።",
    "backToAnimalList": "ወደ የእንስሳት ዝርዝር ተመለስ",
    "addAnotherAnimal": "ሌላ እንስሳ ጨምር",
    "animalDetailsUpdated": "የእንስሳት ዝርዝሮች በተሳካ ሁኔታ ዘምነዋል",
    "animalUpdatedSuccessfully": "እንስሳ በተሳካ ሁኔታ ዘምኗል",
    "animalNotUpdated": "እንስሳ አልዘመነም።",
    "notMember": "አባል አይደሉም?",
    "requestAccess": "መዳረሻ ይጠይቁ",
    "typePassword": "እባክዎ የይለፍ ቃል ይተይቡ።",
    "minChars": "ቢያንስ 6 ቁምፊዎች",
    "typeConfirmPassword": "አረጋግጥ የይለፍ ቃል ተይብ",
    "passConfig": "የይለፍ ቃል ማረጋገጫው አይዛመድም።",
    "invalidEmailMobile": "ልክ ያልሆነ የኢሜይል/ሞባይል ቅርጸት",
    "passwordNotEmpty": "የይለፍ ቃል ባዶ ሊሆን አይችልም።",
    "passwordLength": "የይለፍ ቃል ርዝመት ከ 8 ቁምፊዎች ያነሰ ሊሆን አይችልም",
    "cityVillage": "ከተማ / መንደር",
    "districtRegion": "አውራጃ / ክልል",
    "alreadyHaveAnAccount": "ቀድሞውንም መለያ አለህ?",
    "genetypeUpdated": "GenoType ተዘምኗል",
    "genetypeNotUpdated": "GenoType አልዘመነም።",
    "sellTrade": "መሸጥ/ንግድ",
    "milkingDevon": "የዴቨን እርባታ ክምችት ለሽያጭ",
    "detailedDescription": "ዝርዝር መግለጫ",
    "longPara": "የአሜሪካ ወተት ዴቨን ቡልስ ጊደሮች እና ላሞች። ",
    "contactSeller": "ሻጩን ያግኙ",
    "enterListingTitle": "የዝርዝር ርዕስ አስገባ",
    "livestocktype": "የእንስሳት ዓይነት",
    "uploadImage": "ምስል ስቀል",
    "mobilePhone": "የሞባይል ስልክ ቁጥር",
    "myLivestock": "የኔ ከብቶች",
    "livestockObservations": "የእንስሳት እርባታ ምልከታዎች",
    "selectFromRegisteredAnimals": "ከተመዘገቡት እንስሳት ዝርዝር ውስጥ ይምረጡ",
    "selectOption": "አማራጭ ይምረጡ",
    "selectTypeObservation": "የእይታ አይነትን ይምረጡ",
    "attachVeteinaryDocument": "የእንስሳት ህክምና ሰነድ ያያይዙ",
    "addsensorReading": "ዳሳሽ ንባብ ያክሉ",
    "myDocument": "የእኔ ሰነዶች",
    "enterAKeyword": "ቁልፍ ቃል ያስገቡ",
    "documentType": "የሰነድ አይነት",
    "registerEditLivestock": "የእንስሳት እርባታን ይመዝገቡ/ ያርትዑ",
    "editLivestockProfile": "የእንስሳት እርባታ መገለጫን ያርትዑ",
    "copy": "ቅዳ",
    "dateOfRegister": "የመመዝገቢያ ቀን",
    "livestockType": "የእንስሳት ዓይነት",
    "registerNewLivestock": "አዲስ የእንስሳት ሀብት ይመዝገቡ",
    "enterUniqueTag": "ልዩ መለያ ያስገቡ",
    "color": "ቀለም",
    "gender": "ጾታ",
    "male": "ወንድ",
    "female": "ሴት",
    "damm": "ግድብ",
    "siree": "ሳይሬ",
    "dateOfSaleAuction": "የተሸጠ/የጨረታ ሽያጭ ቀን",
    "auctionRecord": "የሟች ዝርዝር የጨረታ መዝገብ",
    "distinguishingFeatures": "የመለየት ባህሪዎች",
    "keywordListing": "ቁልፍ ቃል ወይም ዝርዝር መታወቂያ",
    "adType": "የማስታወቂያ አይነት",
    "activeListingFund": "1 ገባሪ ዝርዝር ተገኝቷል",
    "setupSensors": "ዳሳሾችን ያዋቅሩ",
    "serialNumber": "ተከታታይ ቁጥር",
    "sensorLocation": "ዳሳሽ አካባቢ",
    "sensorType": "ዳሳሽ ዓይነት",
    "installationDate": "የመጫኛ ቀን",
    "ExpirationDate": "የመጠቀሚያ ግዜ",
    "addGeo": "ጂኦግራፊያዊ አካባቢን ያክሉ",
    "addMoreSensors": "ተጨማሪ ዳሳሾችን ያክሉ",
    "trackAndTrace": "ይከታተሉ እና ይከታተሉ",
    "createNewShipment": "አዲስ ጭነት ይፍጠሩ",
    "workflowReference": "የስራ ፍሰት ማጣቀሻ",
    "invoiceDate": "የክፍያ መጠየቂያ ቀን",
    "trackShipment": "ጭነትን ይከታተሉ",
    "totalShipments": "ጠቅላላ መላኪያዎች",
    "activeShipment": "ንቁ መላኪያዎች",
    "completedObjectives": "የተጠናቀቁ ዓላማዎች",
    "processedPayments": "የተከናወኑ ክፍያዎች",
    "pointOfDestination": "የመድረሻ ነጥብ",
    "sellerInformation": "የሻጭ መረጃ",
    "selectSellerConsignor": "ሻጭ/ላኪ ይምረጡ",
    "pointOfOrigin": "የመነሻ ነጥብ",
    "buyerInfo": "የገዢ መረጃ",
    "selectBuyerConsignor": "ገዢ/ላኪ ይምረጡ",
    "addSensorTriggers": "ዳሳሽ ቀስቅሴዎችን ያክሉ",
    "processPayments": "የሂደት ክፍያዎች",
    "defineShippingContract": "የማጓጓዣ ውልን ይግለጹ",
    "addDigitize": "አክል",
    "currentlyOnFarm": "በአሁኑ ጊዜ በእርሻ ላይ",
    "addSire": "Sire ጨምር",
    "addApproval": "ማጽደቅን ጨምር",
    "addCollection": "ስብስብ ያክሉ",
    "addStraws": "እንጆሪዎችን ይጨምሩ",
    "addPack": "ጥቅል አክል",
    "addPostage": "ፖስታ አክል",
    "searchBySire": "በሲር ይፈልጉ",
    "anyDataChangeMightBeLost": "ማንኛውም የውሂብ ለውጦች ሊጠፉ ይችላሉ።",
    "wouldYouLikeToSaveOrWantToLeaveWithoutSaving": "ማስቀመጥ ይፈልጋሉ ወይም ሳያስቀምጡ መሄድ ይፈልጋሉ",
    "leave": "ተወው",
    "stay": "ይቆዩ",
    "animalFarm": "የእንስሳት እርባታ",
    "animalFarmH": "የእንስሳት እርባታ",
    "animalOrigin": "የእንስሳት አመጣጥ",
    "animalOriginH": "የእንስሳት አመጣጥ",
    "farmOfOrigin": "የመነሻ እርሻ",
    "farmOfOriginH": "የመነሻ እርሻ",
    "selectFarm": "እርሻን ይምረጡ",
    "searchFarm": "እርሻን ፈልግ",
    "confirmation": "ማረጋገጫ",
    "proceed": "ቀጥል።",
    "ok": "እሺ",
    "animal": {
      "tagH": "መለያ",
      "tagNumberH": "መለያ ቁጥር: ቀለም እና ቁጥር ማከል ይችላሉ. ",
      "goveRegNoH": "በመንግስት ድርጅት ሲመዘገቡ የተሰጠ ቁጥር",
      "birthWeightH": "የጥጃ ልደት ክብደት",
      "birthEaseH": "በከብት እርባታ መወለድ ተፈጥሯዊ ሂደት ቢሆንም አንዳንድ ጊዜ ግድቡ ከአርሶ አደሩ/አርብቶ አደሩ እርዳታ የሚፈልግበት የወሊድ ችግር ሊኖር ይችላል።",
      "birthFarmH": "የእንስሳት መገኛ/የትውልድ እርሻ።",
      "surrogateDamH": "ከለጋሽ ወንድ እና ከለጋሽ ሴት የተዳቀለው እንቁላል ለበለጠ እድገት የሚተከልበት የሴት ላም መታወቂያ።",
      "ownerH": "ይህ የእንስሳቱ ባለቤት ስም ነው.",
      "damH": "የሴት ወላጅ/የእንስሳት እናት መታወቂያ።",
      "sireH": "የወንድ ወላጅ/የእንስሳቱ አባት መታወቂያ።",
      "breedH": "ዝርያ ተመሳሳይ የሆነ መልክ (phenotype)፣ ተመሳሳይነት ያለው ባህሪ እና/ወይም ሌሎች ተመሳሳይ ዝርያ ካላቸው ፍጥረታት የሚለይ ልዩ የቤት እንስሳት ቡድን ነው።",
      "conceptionMethodH": "እንስሳው እንዴት እንደተፀነሰ.",
      "genderH": "የእንስሳት ጾታ.",
      "dobH": "የእንስሳቱ የትውልድ ቀን.",
      "operatorH": "የዚህን እንስሳ መረጃ የሚሞላው ሰው ስም።",
      "removalFarmH": "የእንስሳት እርባታ ",
      "dateOfRemovalH": "የእንስሳት መወገድ ቀን",
      "destinationOfRemoval": "የተወገደ እንስሳ መድረሻ ቦታ",
      "reasonOfRemovalH": "የእንስሳት መወገድ ምክንያት",
      "trackingNumberH": "እንስሳው በሚወገድበት ጊዜ ለእንስሳው የተሰጠው ቁጥር",
      "brandH": "ብራንድ - በቀላሉ ላሟ ላይ የተቃጠለ ቋሚ ምልክት።",
      "tattoH": "በእንስሳት ላይ ንቅሳት.",
      "hornStatusH": "እንስሳው የተቀደደ ይሁን።",
      "animalOriginH": "የእንስሳት መገኛ አገር.",
      "previousOwnerH": "እንስሳው ጎልማሳ ከሆነ የቀድሞ ባለቤት ስም።",
      "twinH": "ይህ መስክ እንስሳው መንታ እንዳለው ወይም እንደሌለው ይናገራል.",
      "regBreedAssoNoH": "በዘር ማኅበራት/ማኅበራት መመዝገብ።",
      "breedAssoNameH": "እንስሳው የተመዘገበባቸው ማህበራት/ማህበራት ስም",
      "breederH": "ይህ እንስሳውን ያቀረበው ድርጅት ስም ነው.",
      "breeder": "አርቢ",
      "noteH": "ስለ እንስሳው ጠቃሚ ማስታወሻ (ዎች)።",
      "accuracyWeight_for_field": "ትክክለኛ ክብደት",
      "conception": "ፅንሰ-ሀሳብ",
      "addAnAnimal": "እንስሳ ጨምር",
      "addAnimal": "እንስሳ ይጨምሩ",
      "registerAnAnimal": "እንስሳ ይመዝገቡ",
      "uploadAnAnimal": "እንስሳ ስቀል",
      "animalRegistration": "የእንስሳት ምዝገባ",
      "animalDetails": "የእንስሳት ዝርዝሮች",
      "tag": "መለያ",
      "tagNumber": "የመለያ ቁጥር",
      "govtRegNumber": "መንግስት ",
      "birthWeight": "የልደት ክብደት (ፓውንድ)",
      "birthEase": "የመውለድ ቀላልነት",
      "birthFarm": "የወሊድ እርሻ",
      "surrogateDam": "ምትክ ግድብ",
      "owner": "ባለቤት",
      "ownershipType": "የባለቤትነት አይነት",
      "animalDiseaseRecord": "Animal Disease መዝገብ",
      "govtReg": "መንግስት ",
      "regDate": "Reg ቀን",
      "dam": "ግድብ",
      "sire": "ሳይሬ",
      "heifer": "ጊደር",
      "steer": "መምራት",
      "calf": "ጥጃ",
      "farmHerd": "እርሻ/መንጋ",
      "femaleCalf": "ሴት ጥጃ",
      "maleCalf": "ወንድ ጥጃ",
      "newCalves": "አዲስ ጥጃዎች",
      "breed": "ዘር",
      "conceptionMethod": "የፅንሰ-ሀሳብ ዘዴ",
      "gender": "ጾታ",
      "dateOfBirth": "የተወለደበት ቀን",
      "operator": "ኦፕሬተር",
      "animalRemovedFarm": "የእንስሳት እርባታ",
      "dateOfAnimalRemoval": "የእንስሳት መወገድ ቀን",
      "destinationOfRemovedAnimal": "የተወገዱ እንስሳት መድረሻ",
      "reasonOfRemoval": "የማስወገድ ምክንያት",
      "optionalAnimalInformation": "አማራጭ የእንስሳት መረጃ",
      "animalPicture": "የእንስሳት ምስል",
      "trackingNumber": "መከታተያ ቁጥር",
      "brand": "የምርት ስም",
      "tatto": "ንቅሳት",
      "hornStatus": "የቀንድ ሁኔታ",
      "animalOrigin": "የእንስሳት አመጣጥ",
      "previosOwner": "የቀድሞዎቹ ባለቤት",
      "twin": "መንታ",
      "InABreedAssociation": "ሬጅ.",
      "nameOfBreedAssociations": "የዘር ማኅበራት ስም",
      "breedAssociations": "የዘር ማኅበራት",
      "breederSupplier": "አርቢ (አቅራቢ)",
      "importAnimal": "እንስሳ አስመጣ",
      "loadingAnimals": "እንስሳትን በመጫን ላይ... እባክዎ ይጠብቁ",
      "totalRegAnimals": "ጠቅላላ Reg. ",
      "totalPregnantAnimals": "አጠቃላይ እርጉዝ እንስሳት",
      "pregnantAnimalHistory": "ነፍሰ ጡር የእንስሳት ታሪክ",
      "dailyAnimalPregnancyUpdates": "ዕለታዊ የእንስሳት እርግዝና ዝመናዎች",
      "animalHistory": "የእንስሳት ታሪክ",
      "dailyAnimalUpdates": "ዕለታዊ የእንስሳት ዝመናዎች",
      "totalPregnant": "አጠቃላይ እርጉዝ",
      "totalNewBorn": "ጠቅላላ አዲስ የተወለደ",
      "searchByIDGOVRegTag": "በID ፣GOV Reg እና Tag ፈልግ",
      "noANIMALAVAILABLE": "ምንም እንስሳ አይገኝም",
      "associationNumber": "የማህበሩ ቁጥር",
      "associationName": "የማህበሩ ስም",
      "destinationName": "የመድረሻ ስም",
      "plastic": "ፕላስቲክ",
      "metal": "ብረት",
      "naturalMating": "ተፈጥሯዊ ማዳቀል",
      "artificialInsemination": "ሰው ሰራሽ ማዳቀል",
      "embryoTransfer": "የፅንስ ሽግግር",
      "noAssistance": "ምንም እገዛ የለም።",
      "someAssistance": "የተወሰነ እርዳታ",
      "mechanicalAssistance": "መካኒካል እርዳታ",
      "aCesareanSection": "ቄሳራዊ ክፍል",
      "abnormalDelivery": "ያልተለመደ መላኪያ",
      "male": "ወንድ",
      "female": "ሴት",
      "castrated": "የተቀዳ",
      "sale": "ሽያጭ",
      "slaughter": "እርድ",
      "death": "ሞት",
      "theft": "ስርቆት",
      "other": "ሌላ",
      "horned": "ቀንድ ያለው",
      "polled": "አስተያየት ሰጥተዋል",
      "dehorned": "ተወግዷል",
      "details": "ዝርዝሮች",
      "performance": "አፈጻጸም",
      "geneticWorth": "የዘረመል ዋጋ",
      "healthRecord": "የጤና መዝገብ",
      "genotypeData": "Genotype ውሂብ",
      "reminders": "አስታዋሾች",
      "activityLog": "የእንቅስቃሴ ምዝግብ ማስታወሻ",
      "activityLogDetails": "የእንቅስቃሴ ምዝግብ ማስታወሻ ዝርዝሮች",
      "editAnimal": "እንስሳ አርትዕ",
      "familyInfo": "የቤተሰብ መረጃ",
      "breedInfo": "የዘር መረጃ",
      "identification": "መለየት",
      "removalInfo": "የማስወገጃ መረጃ",
      "iDOfAnimalDam": "የእንስሳት ግድብ መታወቂያ።",
      "iDOfAnimalSire": "የእንስሳት ሲር መታወቂያ።",
      "iDOfDamEmbryoUsed": "ፅንሱ ጥቅም ላይ የዋለው የግድብ መታወቂያ።",
      "animalHasATwinOrNot": "እንስሳው መንታ አለው ወይም የለውም።",
      "breedType": "የዘር ዓይነት",
      "breedOfTheAnimal": "ይህ የእንስሳት ዝርያ ነው.",
      "regBreedAssociations": "በዘር ማኅበራት/ማኅበራት መመዝገብ።",
      "nameOfAssociationsSocieties": "እንስሳው የተመዘገበባቸው ማህበራት/ማህበራት ስም።",
      "nameOfTheOrgSuppliedAnimal": "ይህ እንስሳውን ያቀረበው ድርጅት ስም ነው.",
      "countryOriginAnimal": "የእንስሳት መገኛ አገር.",
      "birthFarmID": "የልደት እርሻ መታወቂያ",
      "farmIDAnimalBorn": "እንስሳው የተወለደበት የእርሻ መታወቂያ.",
      "currentOwner": "የአሁን ባለቤት",
      "nameOfOwnerAnimal": "ይህ የእንስሳቱ ባለቤት ስም ነው.",
      "registrationDate": "የምዝገባ ቀን",
      "previousOwner": "የቀድሞ ባለቤት",
      "nameOfOperator": "የኦፕሬተር ስም",
      "dateAnimalRemoved": "እንስሳ የሚወገድበት ቀን።",
      "destinationPlaceRemovedAnimal": "ለተወገዱ እንስሳት መድረሻ ቦታ",
      "namePersonFillAnimalInformation": "የዚህን እንስሳ መረጃ የሚሞላው ሰው ስም።",
      "reasonOfAnimalRemoval": "የእንስሳት መወገድ ምክንያት",
      "reasonWhyTheAnimalIsRemoved": "እንስሳው ለምን እንደሚወገድ ምክንያት",
      "processingDate": "የማስኬጃ ቀን",
      "DateInformationFilledChanged": "የአሁኑ መረጃ የተሞላበት ወይም የተቀየረበት ቀን።",
      "animalID": "የእንስሳት መታወቂያ",
      "UniqueIdAnimal": "ይህ የእንስሳው ልዩ መታወቂያ ነው።",
      "plasticTagNumber": "የፕላስቲክ መለያ ቁጥር",
      "numberAnimalTag": "የእንስሳት መለያ ቁጥር.",
      "rFTagNumber": "የ RF መለያ ቁጥር",
      "numberAnimalRFTag": "የእንስሳት RF መለያ ቁጥር.",
      "govtRegNumb": "መንግስት ",
      "govtRegistrationNumber": "የመታወቂያ ዝርዝሮች የግለሰቡን ስም እና አድራሻ፣ የግለሰቡን የሂደት አገልግሎት ወኪል፣ የሚካሄደው እንቅስቃሴ ቦታ እና ግለሰቡ የሚሰጠውን አገልግሎት መግለጫ ሊያካትት ይችላል።",
      "numberAssignedAnimalIsRemoved": "የመከታተያ ቁጥር የእንስሳትን እንቅስቃሴ ለመከታተል ከሚጠቀሙባቸው የእንስሳት መታወቂያዎች አንዱ ነው።",
      "dateOfAnimalRegistration": "የእንስሳት ምዝገባ ቀን",
      "stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal": "ብራንድ - በቀላሉ ላሟ ላይ የተቃጠለ ቋሚ ምልክት።",
      "tattoOnAnimal": "በእንስሳት ላይ ንቅሳት.",
      "whetherTheAnimalIsDehorned": "እንስሳው የተቀደደ ይሁን።",
      "milkingAnimals": "የእንስሳት ወተት",
      "studAnimals": "ስቱድ እንስሳት",
      "animalInseminationRecord": "የእንስሳት ማዳቀል መዝገብ",
      "numOfStrawsOrdered": "የታዘዙ ገለባዎች ብዛት",
      "totalNumOfStraws": "ጠቅላላ የዛፎች ብዛት",
      "strawId": "የገለባ መታወቂያ",
      "addSireAutomation": "Sire Automation ያክሉ",
      "addApprovalAutomation": "ማጽደቅ አውቶማቲክን ያክሉ",
      "addCollectionAutomation": "የስብስብ አውቶማቲክን ያክሉ",
      "addStrawsAutomation": "Straws አውቶማቲክ አክል",
      "addPackAutomation": "ጥቅል አውቶሜሽን አክል",
      "addPostageAutomation": "የፖስታ አውቶማቲክ አክል",
      "searchBySire": "በሳይር ፍለጋ",
      "numberOfProgenies": "የትውልዶች ብዛት",
      "sireEdit": "Sire አርትዕ",
      "searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId": "በስትሮው መታወቂያ፣ ጠቅላላ የገለባ ቁጥሮች፣ ባች ቁጥር እና የመገኛ ቦታ መታወቂያ ይፈልጉ",
      "searchByPackIdNumberOfStrawsOrderedPackingTechnicia": "በማሸጊያ መታወቂያ ይፈልጉ፣ የታዘዙ የገለባ ብዛት፣ የማሸጊያ ቴክኒሺያ",
      "searchByCollectionAndPreparationTechnicia": "በስብስብ እና የዝግጅት ቴክኒሻን ይፈልጉ",
      "registerSemenAutomation": "የሴሜን አውቶሜሽን ይመዝገቡ",
      "addSemenAutomation": "የሴሜን አውቶሜትሽን ጨምር",
      "strawAutomationRegistered": "ገለባ አውቶሜሽን ተመዝግቧል",
      "strawAutomationRegisteredNotRegistered": "ገለባ አውቶሜሽን አልተመዘገበም።",
      "sireAutomationRegistered": "ሲር አውቶሜሽን ተመዝግቧል",
      "sireAutomationNotRegistered": "Sire Automation አልተመዘገበም።",
      "postageAutomationIsRegistered": "የፖስታ አውቶሜሽን ተመዝግቧል",
      "postageAutomationNotRegistered": "የፖስታ አውቶሜሽን አልተመዘገበም።",
      "packAutomationIsRegistered": "ጥቅል አውቶሜሽን ተመዝግቧል",
      "packAutomationNotRegistered": "ጥቅል አውቶሜሽን አልተመዘገበም።",
      "postageAutomationIsUpdated": "የፖስታ አውቶሜሽን ተዘምኗል",
      "postageAutomationNotUpdated": "የፖስታ አውቶሜሽን አልዘመነም።",
      "packAutomationIsUpadted": "ጥቅል አውቶሜሽን ተጭኗል",
      "packAutomationNotUpadted": "ጥቅል አውቶሜሽን አልተጫነም።",
      "collectionAutomationUpdated": "የስብስብ አውቶሜሽን ተዘምኗል",
      "collectionAutomationNotUpdated": "የስብስብ አውቶማቲክ አልዘመነም።",
      "approvalAutomationIsUpdated": "ማጽደቅ አውቶማቲክ ተዘምኗል",
      "approvalAutomationIsNotUpdated": "ማጽደቅ አውቶማቲክ አልተዘመነም።",
      "collectionAutomationRegistered": "የስብስብ አውቶሜሽን ተመዝግቧል",
      "collectionAutomationNotRegistered": "የስብስብ አውቶማቲክ አልተመዘገበም።",
      "approvalAutomationIsRegistered": "ማጽደቅ አውቶሜሽን ተመዝግቧል",
      "approvalAutomationIsNotRegistered": "ማጽደቅ አውቶሜሽን አልተመዘገበም።",
      "strawAutomationUpdated": "ገለባ አውቶማቲክ ተዘምኗል",
      "strawAutomationIsNotUpdated": "Straw Automation አልዘመነም።",
      "searchSire": "Sire ፈልግ",
      "strawsEdit": "Straws አርትዕ",
      "nextAnimals": "ቀጣይ እንስሳ",
      "performanceInfo": {
        "milk": "ወተት",
        "liveweight": "የቀጥታ ክብደት",
        "score": "ነጥብ",
        "fertility": "የመራባት",
        "measurements": "መለኪያዎች",
        "dailyProteinYield": "ዕለታዊ የፕሮቲን ምርት",
        "amountProteinMilkCowDay": "በአንድ ቀን ውስጥ ከላም የተገኘ ወተት ውስጥ ያለው የፕሮቲን መጠን።",
        "dailyMilkYield": "በየቀኑ የወተት ምርት",
        "volumeMilkCowDay": "በተወሰነ ቀን ውስጥ ከተወሰነ ላም የተገኘ የወተት መጠን.",
        "dailyFatYield": "ዕለታዊ የስብ ምርት",
        "amountFatMilkCowDay": "በተወሰነ ቀን ውስጥ ከላም የተገኘ ወተት ውስጥ ያለው የስብ መጠን.",
        "dailyProteinContent": "ዕለታዊ የፕሮቲን ይዘት",
        "dailyFatContent": "ዕለታዊ ስብ ይዘት",
        "milkLactose": "ወተት ላክቶስ",
        "amountLactoseMilk": "በወተት ውስጥ ያለው የላክቶስ መጠን።",
        "milkUrea": "ወተት ዩሪያ",
        "indicatorAmountCrudeProtein": "በላም አመጋገብ ውስጥ ያለውን የድፍድፍ ፕሮቲን መጠን አመላካች",
        "lactationNumber": "የጡት ማጥባት ቁጥር",
        "ordinalNumLactation": "የጡት ማጥባት መደበኛ ቁጥር.",
        "lengthOfLactation": "የጡት ማጥባት ጊዜ (ለምሳሌ 23 ቀናት)",
        "lactationLength": "የጡት ማጥባት ርዝመት",
        "milkingFrequency": "የወተት ድግግሞሽ",
        "frequcnyOfMilking": "የማጥባት ድግግሞሽ (ለምሳሌ በቀን 2 ጊዜ)",
        "liveWeightInformation": "የቀጥታ ክብደት መረጃ",
        "currentWeight": "የአሁኑ ክብደት",
        "weightAnimal": "የእንስሳቱ ክብደት.",
        "postWeaningGain": "ከጡት ማጥባት በኋላ ትርፍ",
        "dailyGainInAnimalWeightWeaning": "ጡት ካጠቡ በኋላ በየቀኑ የእንስሳት ክብደት መጨመር.",
        "weaningWeight": "የጡት ማጥባት ክብደት",
        "weightAnimalMeasuredWeaning": "በጡት ማጥባት ቀን የሚለካ የእንስሳት ክብደት።",
        "averageDailyGain": "አማካኝ ዕለታዊ ትርፍ",
        "averageAmountWeightAnimalGainFeedingPeriod": "በአመጋገብ ወቅት የእንስሳት አማካይ የክብደት መጠን በየቀኑ ይጨምራል",
        "carcassWeight": "የሬሳ ክብደት",
        "weightAnimalsHideInternalOrgansRemoved": "ከጭንቅላቱ, ከድብቅ እና ከውስጥ አካላት ከተወገዱ በኋላ የእንስሳት ክብደት.",
        "weightAtCalving": "በወሊድ ጊዜ ክብደት",
        "weightAtTheTimeOfCalving": "በወሊድ ጊዜ ክብደት.",
        "yearlingWeight": "አመታዊ ክብደት",
        "weightYearOldAnimal": "የአንድ አመት የእንስሳት ክብደት.",
        "somaticCellScore": "የሶማቲክ ሕዋስ ውጤት",
        "somaticCellScoreIndicatorMastitis": "የሶማቲክ ሕዋስ ውጤት ለ mastitis አመላካች. ",
        "lastUpdate": "የመጨረሻው ዝመና",
        "bodyConditionScore": "የሰውነት ሁኔታ ውጤት",
        "scoreAnimalFat": "ምን ያህል ስብ እንዳለው የእንስሳት ነጥብ።  ",
        "teatScore": "የጡት ነጥብ",
        "scoreMeasureingShapeTeats": "የጡት መጠን ውጤቶች የጡት ርዝማኔ እና የክብደት ግላዊ ምዘናዎች ሲሆኑ ከ9 (በጣም ትንሽ) እስከ 1 (በጣም ትልቅ) ናቸው። ",
        "udderScore": "የጡት መታገድ ነጥብ",
        "scoreMeasureingShapeOfUdder": "የውጤት መለኪያ የጡት ቅርጽ (1-9 ነጥብ)። ",
        "whetherAnimalEasyBirthDifficult": "በከብት እርባታ መወለድ ተፈጥሯዊ ሂደት ቢሆንም አንዳንድ ጊዜ ግድቡ ከአርሶ አደሩ/አርብቶ አደሩ እርዳታ የሚፈልግበት የወሊድ ችግር ሊኖር ይችላል።",
        "totalLongevity": "አጠቃላይ ረጅም ዕድሜ",
        "survivalLactationTraitCowCulledBreeding": "ከ 1 ኛ እስከ 5 ኛ መታለቢያ መትረፍ. ",
        "docility": "ትምህርት",
        "circumferenceBullScrotal": "የበሬ ስክሊት ዙሪያ",
        "intervalSuccessInsemination": "ከመጀመሪያው እስከ ስኬታማ የማዳቀል ጊዜ.",
        "ageAtFirstCalving": "በመጀመሪያ የመውለድ ዕድሜ",
        "ageCowCalving": "በመጀመሪያው ግልገል ውስጥ የላም ዕድሜ ስንት ነው.",
        "calvingInterval": "የመውለድ ክፍተት",
        "periodCalving": "ከአንድ ልጅ እስከሚቀጥለው ልጅ ድረስ ያለው ጊዜ።",
        "scrotalCircumference": "Scrotal Circumference",
        "estrusDetection": "ኢስትሮስ ማወቂያ",
        "trackingBehaviorAnimalDetectingEstrus": "የላም ኢስትሮስን ለመለየት የእንስሳትን እንቅስቃሴ ባህሪ መከታተል።",
        "presenceOfEstrus": "የ Estrus መኖር",
        "isCowInEstrusStage": "ላም በ estrus መድረክ ላይ ስትሆን ነው ወይስ አይደለም",
        "matureWeight": "የበሰለ ክብደት",
        "weightAnimalDefinedAge": "በተወሰነ ዕድሜ ውስጥ የእንስሳት ክብደት።",
        "matureHeight": "የበሰለ ቁመት",
        "heightAnimalDefinedAge": "በተወሰነ ዕድሜ ውስጥ የእንስሳት ቁመት።",
        "footClawSet": "የእግር ጥፍር አዘጋጅ",
        "shapeAnimalClaw": "የእንስሳት ጥፍር ቅርጽ.",
        "pulmonaryArterialPressure": "የሳንባ የደም ቧንቧ ግፊት",
        "animalBloodPreasure": "የእንስሳት የደም ግፊት.",
        "footAngle": "የእግር አንግል",
        "shapeAnimalFoot": "የእንስሳት እግር ቅርጽ.",
        "ribEyeArea": "የጎድን አጥንት አካባቢ",
        "amountRibEyeArea": "የጎድን አጥንት አካባቢ መጠን.",
        "ultrasoundFat": "አልትራሳውንድ ስብ",
        "measureFatAmount": "የስብ መጠን መለካት.",
        "ultrasoundIntramuscularFat": "አልትራሳውንድ Intramuscular Fat",
        "ultrasoundRibEyeArea": "አልትራሳውንድ ሪብ-አይን አካባቢ",
        "measureRibeyeArea": "የሪቤዬ አካባቢ መለኪያ.",
        "fatThickness": "ወፍራም ውፍረት",
        "amountAnimalBackFat": "የእንስሳት ጀርባ ስብ መጠን.",
        "marbling": "ማርሊንግ",
        "marballingMeasurement": "ማርሊንግ በጡንቻ ውስጥ እና በጡንቻ ፋይበር እሽጎች መካከል የሚከማች የሚታየው ያልተሟላ (ጤናማ) ጡንቻማ ስብ ነው።",
        "dryMatterIntake": "የደረቅ-ቁስ ቅበላ",
        "amountFeedAnimalConsumesAMoisture": "አንድ እንስሳ ከእርጥበት-ነጻ በሆነ መሠረት በቀን የሚበላው መኖ መጠን።"
      },
      "feedsName": "የምግቦች ስም",
      "feedName": "የምግቡ ስም",
      "firstFeedQuantity": "የመጀመሪያ ምግብ ብዛት",
      "additionalFeed": "ተጨማሪ ምግብ",
      "cloversRyeGrasses": "ክሎቨርስ ፣ የሬሳ ሳሮች",
      "greenFodderHayLegumes": "አረንጓዴ መኖ ፣ አረም ፣ ጥራጥሬዎች",
      "feedsRegisteredSuccessfully": "ምግቦች በተሳካ ሁኔታ ተመዝግበዋል",
      "feedsNotRegistered": "ምግቦች አልተመዘገቡም",
      "fEEDQUANTITY": "የምግብ ብዛት",
      "feedQuantity": "የምግብ ብዛት",
      "fEEDNAME": "የምግቡ ስም",
      "nOFEEDINFOAVAILABLE": "ምንም የምግብ መረጃ አይገኝም",
      "searchByFeedName": "በምግቡ ስም ይፈልጉ",
      "loadingFeedInfo": "የምግብ መረጃን በመጫን ላይ... እባክዎ ይጠብቁ",
      "todayFeedInfo": "የዛሬ የምግብ መረጃ",
      "feedInfo": "የምግብ መረጃ",
      "loremIpsumDolorSitAmet": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      "geneticWorthInfo": {
        "breedingValueEconomicIndex": "ይህ የእርባታ ዋጋ ለኢኮኖሚያዊ መረጃ ጠቋሚ ስሌት ጥቅም ላይ ይውላል.",
        "dailyProteinYieldUsed": "በየቀኑ ጥቅም ላይ የሚውለው የፕሮቲን ምርት",
        "weightAssignedBreedingDailyProteinYield": "ከ \"ዕለታዊ የፕሮቲን ምርት\" ጋር የሚዛመድ የመራቢያ እሴት የተመደበው ክብደት። ",
        "dailyProteinYieldWeight": "ዕለታዊ የፕሮቲን ምርት ክብደት",
        "rankAnimalInRelationshipEconomicIndex": "ከኤኮኖሚ መረጃ ጠቋሚ ጋር ባለው ግንኙነት የእንስሳት ደረጃ.",
        "economicIndexRank": "የኢኮኖሚ ኢንዴክስ ደረጃ",
        "percentileEconomicIndexFall": "የትኛው የኢኮኖሚ መረጃ ጠቋሚ የወደቀበት መቶኛ።",
        "economicIndexPercentile": "የኢኮኖሚ ኢንዴክስ መቶኛ",
        "accuracyOfEconomicIndex": "የኢኮኖሚ መረጃ ጠቋሚ ትክክለኛነት.",
        "economicIndexAccuracy": "የኢኮኖሚ ኢንዴክስ ትክክለኛነት",
        "weightedAverageOfBreedingValues": "የመራቢያ እሴቶች አማካይ ክብደት።",
        "economicIndex": "የኢኮኖሚ መረጃ ጠቋሚ",
        "rankOfAnimalInRelationshipBreeding": "የእንስሳት ደረጃ ከተዛማጅ የመራቢያ እሴት ጋር በተገናኘ።",
        "dailyProteinYieldBreedingValueRank": "ዕለታዊ የፕሮቲን ምርት የመራቢያ እሴት ደረጃ ",
        "percentileBreedingFalls": "የትኛው የመራቢያ ዋጋ እንደወደቀ መቶኛ።",
        "dailyProteinYieldBreedingPercentile": "ዕለታዊ የፕሮቲን ምርት የመራቢያ ዋጋ በመቶኛ ",
        "accuracyEstimatedBreeding": "የተገመተው የእርባታ ዋጋ ትክክለኛነት.",
        "dailyProteinYieldBreedingAccuracy": "ዕለታዊ የፕሮቲን ምርት የመራቢያ እሴት ትክክለኛነት",
        "estimatedBreedingTraitDailyProteinYield": "የባህሪው ግምታዊ የመራቢያ እሴት \"ዕለታዊ የፕሮቲን ምርት።",
        "dailyProteinYieldBreedingValue": "ዕለታዊ የፕሮቲን ምርት የመራቢያ እሴት ",
        "pathToTheDirectoryScriptsBreeding": "የመራቢያ ዋጋን ለማስላት ያገለገሉ ስክሪፕቶችን የያዙ በሃርድ ድራይቭ ላይ ወደ ማውጫው የሚወስድ መንገድ።",
        "scriptsPath": "የስክሪፕቶች ዱካ",
        "softwarePackageBreeding": "የመራቢያ ዋጋን ለማስላት ጥቅም ላይ የዋለ የሶፍትዌር ጥቅል።",
        "breedingValueSoftware": "የመራቢያ እሴት ሶፍትዌር",
        "methodCalculateBreeding": "እርባታ ለማስላት ጥቅም ላይ የዋለው ዘዴ",
        "breedingValueMethod": "የመራቢያ እሴት ዘዴ",
        "trait": "ባህሪ",
        "tools": "መሳሪያዎች",
        "geneticWorth": "የዘረመል ዋጋ",
        "dailyProteinYield": "ዕለታዊ የፕሮቲን ምርት",
        "breedingValue": "የመራቢያ እሴት",
        "breedingValueBIFAccuracy": "የመራቢያ እሴት BIF ትክክለኛነት",
        "breedingValuePercentile": "የመራቢያ እሴት መቶኛ",
        "breedingValueRank": "የመራቢያ እሴት ደረጃ",
        "checkLTD": "LTD ያረጋግጡ",
        "ultrasoundDiagnostic": "የአልትራሳውንድ ምርመራ",
        "selectYieldUsed": "ጥቅም ላይ የዋለውን ምርት ይምረጡ",
        "softwareName": "የሶፍትዌር ስም",
        "animalGenWorthUpdatedSuccessfully": "Animal Gen Worth በተሳካ ሁኔታ ዘምኗል"
      },
      "addNote": "ማስታወሻ ጨምር",
      "enterNote": "ማስታወሻ አስገባ",
      "noteIsRequired": "ማስታወሻ ያስፈልጋል",
      "noteMustBeLessThan50Characters": "ማስታወሻ ከ 50 ቁምፊዎች ያነሰ መሆን አለበት",
      "noteAdded": "ማስታወሻ ታክሏል።",
      "noteNotAdded": "ማስታወሻ አልተጨመረም።",
      "noteForAnimal": "ለእንስሳት ማስታወሻ.",
      "noNoteFoundForThisAnimal": "ለዚህ እንስሳ ምንም ማስታወሻ አልተገኘም።",
      "inseminationData": "የማዳቀል ውሂብ",
      "nameOfInseminator": "የአሳዳጊው ስም",
      "activity": "እንቅስቃሴ",
      "searchByNameActivity": "በስም ፣ በእንቅስቃሴ ይፈልጉ",
      "searchByTaskNameNumber": "በተግባር ስም ፣ ቁጥር ይፈልጉ",
      "inseminationDate": "የማዳቀል ቀን",
      "genotypeDataInfo": {
        "genotypeAnimalID": "Genotype የእንስሳት መታወቂያ",
        "iDTubeBloodSampleAnimalNumberGenotypingService": "ይህ ከእንስሳው የተወሰደ የደም ናሙና ወይም በርካታ የጂኖቲፒ አገልግሎት ያለው ቱቦ መታወቂያ ነው።",
        "geneticTechnicianName": "የጄኔቲክ ቴክኒሻን ስም",
        "NameTechnicianBloodSamplesAnimal": "ይህ ከእንስሳው የደም ናሙና የወሰደ ቴክኒሻን ስም ነው።",
        "sNPData": "የ SNP ውሂብ",
        "genotypingServiceNote": "የጄኖታይፕ አገልግሎት ማስታወሻ",
        "InfoGenotypingGenotypingTechnology": "ከጂኖታይፕ ጋር የተያያዙ ሁሉም መረጃዎች እንደ የጂኖቲፒ ኩባንያ ስም፣ ጥቅም ላይ የዋለው የጂኖቲፒ ቴክኖሎጂ፣ የጂኖታይፕ ቀን፣ ወዘተ.",
        "numberOfSNPs": "የ SNPs ብዛት",
        "numberOfSNPsAnimalGenotyped": "እንስሳው ለጂኖታይፕ የተደረገባቸው የኤስኤንፒዎች ብዛት",
        "nameOfTheDrug": "የመድኃኒቱ ስም",
        "animalGenoDataUpdatedSuccessfully": "የእንስሳት ጄኖ ውሂብ በተሳካ ሁኔታ ዘምኗል",
        "animalGenoDataNotUpdated": "የእንስሳት ጄኖ ውሂብ አልዘመነም።",
        "animalIDIsRequired": "የእንስሳት መታወቂያ ያስፈልጋል",
        "techNameIsRequired": "ቴክ ",
        "onlyAlphabetsAreAllowed": "ፊደላት ብቻ ይፈቀዳሉ።",
        "genoDataIsRequired": "የጄኖ ውሂብ ያስፈልጋል",
        "serviceNoteIsRequired": "የአገልግሎት ማስታወሻ ያስፈልጋል",
        "sNPIsRequired": "SNP ያስፈልጋል"
      },
      "healthRecordInfo": {
        "treatment": "ሕክምና",
        "treatmentTakenAnimal": "በእንስሳት ላይ ምን ዓይነት ሕክምና ተወስዷል.",
        "reasonOfTreatment": "የሕክምናው ምክንያት",
        "reasonForTreatment": "የሕክምና ምክንያት",
        "whatReasonOfTreatment": "የሕክምናው ምክንያት ምንድን ነው.",
        "treatmentDate": "የሕክምና ቀን",
        "dateOfTreatment": "የሕክምናው ቀን.",
        "diagnosis": "ምርመራ",
        "nameDiagnosedDiseaseConditionSymptoms": "የተረጋገጠ በሽታ/ሁኔታ ወይም ዋና ምልክቶች ስም",
        "drugID": "የመድኃኒት መታወቂያ",
        "iDOfDrugWhichIsGivenToAnimal": "ለእንስሳት የሚሰጠው መድሃኒት መታወቂያ.",
        "drugName": "የመድሃኒት ስም",
        "nameDrugAnimal": "ለእንስሳት የሚሰጠው መድሃኒት ስም.",
        "drugWithdrawalPeriod": "የመድኃኒት ማስወገጃ ጊዜ",
        "timeAdministrationDrugAnimalMeatMilkHumanConsumption": "ለእንስሳት መድሃኒት ከተሰጠ በኋላ የሚፈጀው ጊዜ ስጋን ወይም ወተትን ለሰው ልጅ ደህንነት ለማረጋገጥ",
        "attendingVeterinarian": "የእንስሳት ሐኪም መገኘት",
        "qualifiedPersonCaseAnimal": "ጉዳዩን/እንስሳውን ያየው ብቃት ያለው ሰው",
        "packID": "የጥቅል መታወቂያ",
        "iDPackTreatment": "ለህክምና ጥቅም ላይ የዋለ ጥቅል መታወቂያ",
        "veterinarianName": "የእንስሳት ሐኪም ስም",
        "animalNoHealthRecord": "ይህ እንስሳ ምንም የጤና መዝገብ የለውም። ",
        "addHealthRecord": "የጤና መዝገብ አክል",
        "healthStatus": "የጤና ሁኔታ",
        "loadingDiseasesPleaseWait": "በሽታዎችን በመጫን ላይ... እባክዎ ይጠብቁ",
        "animalDiseaseRecord": "የእንስሳት በሽታ መዝገብ",
        "animalHealthRecord": "የእንስሳት ጤና መዝገብ",
        "animalTreatmentRecord": "የእንስሳት ሕክምና መዝገብ",
        "loadingHealthData": "የጤና መረጃን በመጫን ላይ...",
        "healthRecord": "የጤና መዝገብ",
        "nameOfDiagnosis": "የምርመራ ስም",
        "treatmentName": "የሕክምና ስም",
        "drugGivenBy": "የተሰጠ መድሃኒት",
        "recessiveDiseases": "ሪሴሲቭ በሽታዎች",
        "recessiveDiseasesMessage": "ይህ በሬ ተሸካሚ የሆነው የትኛው ሪሴሲቭ በሽታ ነው"
      },
      "conceptionInfo": {
        "addNewConception": "አዲስ ፅንሰ-ሀሳብ ጨምር",
        "semenEmbryo": "የዘር ፈሳሽ / ፅንስ",
        "pregnancyCheck": "የእርግዝና ምርመራ",
        "birthInfo": "የልደት መረጃ",
        "searchByInseminatorOrganisationBreedingConception": "በ Inseminator ስም ፣ የድርጅት ስም ፣ የመራቢያ አገልግሎት ቁጥር ፣ የፅንሰ-ሀሳብ ዘዴ ይፈልጉ",
        "deliveryDate": "መላኪያ ቀን",
        "calfId": "የጥጃ መታወቂያ",
        "birthDayOldWeight": "የልደት (የቀኑ) ክብደት",
        "searchByBirthEase": "በልደት ቀላልነት ይፈልጉ",
        "searchPregnancyCheckOperatorMethod": "በእርግዝና ቼክ ኦፕሬተር, የእርግዝና መቆጣጠሪያ ዘዴ ይፈልጉ",
        "pregnancyCheckDate": "የእርግዝና ምርመራ ቀን",
        "conceptionSuccess": "የፅንሰ-ሀሳብ ስኬት",
        "pregnancyCheckOperator": "የእርግዝና መቆጣጠሪያ ኦፕሬተር",
        "pregnancyCheckMethod": "የእርግዝና ምርመራ ዘዴ",
        "recentlyPregnant": "በቅርብ ጊዜ እርጉዝ",
        "pregnancyConfirmationDate": "የእርግዝና ማረጋገጫ ቀን",
        "pregnancyRate": "የእርግዝና መጠን",
        "timePeriodOfPregnancy": "የእርግዝና ጊዜ",
        "semenProduction": "የዘር ፈሳሽ ማምረት",
        "embryoProduction": "የፅንስ ምርት",
        "semen": "የዘር ፈሳሽ",
        "embryoTransferDate": "የፅንስ ሽግግር ቀን",
        "daysOfPregnancy": "የእርግዝና ቀናት",
        "searchSireEmbryoSurrogate": "በሲሬ መታወቂያ፣ በፅንስ ኦርግ ስም፣ በሱሮጌት ግድብ ዝርያ ይፈልጉ",
        "selectDate": "ቀን ይምረጡ",
        "orgnisationNameContainNumber": "የድርጅት ስም ቁጥር መያዝ የለበትም",
        "selectBirthEase": "የወሊድ ምቾትን ይምረጡ",
        "selectUnit": "እባክዎ አንድ ክፍል ይምረጡ",
        "animalConceptionAddedSuccessfully": "የእንስሳት መፀነስ በተሳካ ሁኔታ ታክሏል",
        "postageCustomerName": "ፖስታ የደንበኛ ስም",
        "searchByPostageCustNameCustAddPostId": "በፖስታ የደንበኛ ስም፣ የደንበኛ አድራሻ፣ የፖስታ መታወቂያ ይፈልጉ",
        "dateOfSemenCollection": "የዘር ፈሳሽ የሚሰበሰብበት ቀን",
        "dateOfSemenPreparation": "የዘር ፈሳሽ የሚዘጋጅበት ቀን",
        "semenMotility": "የዘር ፈሳሽ እንቅስቃሴ",
        "semenConcentration": "የዘር ማጎሪያ",
        "postageEdit": "የፖስታ አርትዕ",
        "enterSireId": "የሲር መታወቂያ አስገባ",
        "selectEmbryoOrganisation": "የፅንስ ድርጅትን ይምረጡ",
        "matingDateH": "የተፀነሰበት ቀን፣ ተፈጥሯዊ ማጣመር ወይም ሰው ሰራሽ ማዳቀል።",
        "inseminatorNameH": "የማዳቀል ሂደቱን የሚያከናውን ሰው (የእንስሳት ሐኪም/ቴክኒሻን)",
        "orgNameH": "ለ AI የዘር ፈሳሽ ገለባ የሚያቀርበው ድርጅት ወይም ኩባንያ ስም",
        "brServiceNumH": "የመራቢያ ቁጥርን መመዝገብ (ለምሳሌ 1ኛ፣ 2ኛ ወይም 3ኛ)",
        "conceptionMethodH": "እንቁላሉን በወንድ የዘር ፍሬ በማዳቀል የሚታወቀው የእርግዝና መጀመሪያ የሆነው እንስሳው የተፀነሰበት መንገድ።",
        "sireIdH": "የወንድ ወላጅ/የእንስሳቱ አባት መታወቂያ",
        "damIdH": "የሴት ወላጅ/የእንስሳት እናት መታወቂያ።",
        "sarogatedDamH": "ከለጋሽ ወንድ እና ከለጋሽ ሴት የተዳቀለው እንቁላል ለበለጠ እድገት የሚተከልበት የሴት ላም መታወቂያ።",
        "embOrgNameH": "የፅንሱ ድርጅት ስም",
        "sarogateDamBreedH": "የተተኪው ዝርያ ቀን",
        "sireBreedH": "የሲር ዝርያ አይነት (ብራህማን፣ ቦራን)",
        "pregCheckDateH": "የአልትራሳውንድ እና የደም ምርመራዎችን በመጠቀም ለ 30 ቀናት ያህል እርግዝናን በላሞች ውስጥ ሊታወቅ ይችላል። ",
        "conceptionSuccessH": " በከብቶች ውስጥ፣ የማዳበሪያ መጠን 90% ሲሆን በአማካኝ 55% ገደማ የሚሆነው የፅንስ-የፅንስ ሞትን ያሳያል (Diskin et al., 2006)። ",
        "pregnancyCheckOperatorH": "የእንስሳት ሐኪሞች እና ልዩ የእንስሳት ቴክኒሻኖች በአብዛኛው እነዚህን አገልግሎቶች ለገበሬዎች ይሰጣሉ. ",
        "pregnancyCheckMethodH": "ለከብቶች እርግዝና በጣም በተደጋጋሚ ጥቅም ላይ የሚውሉት ሁለቱ ዘዴዎች የመራቢያ ትራክት (በፊንጢጣ) በእጅ መዳፍ እና የመራቢያ ትራክት transrectal ultrasonography ናቸው።",
        "deliveryDateH": "የወሊድ መወለድ የሚከሰትበት ቀን",
        "calfIdH": "አዲስ የተወለደ ጥጃ መታወቂያ",
        "birthEaseH": "በከብት እርባታ መወለድ ተፈጥሯዊ ሂደት ቢሆንም አንዳንድ ጊዜ ግድቡ ከአርሶ አደሩ/አርብቶ አደሩ እርዳታ የሚፈልግበት የወሊድ ችግር ሊኖር ይችላል።",
        "birthDayOldWeightH": "በተወለደበት ቀን የእንስሳት ክብደት ወይም የአንድ ቀን ወፍ ክብደት",
        "customerAddress": "የደንበኛ አድራሻ"
      },
      "all": "ሁሉም",
      "ungrouped": "ያልተሰበሰቡ እንስሳት",
      "active": "የተሰባሰቡ እንስሳት",
      "updateAnimal": "እንስሳ አዘምን"
    },
    "dashboardS": {
      "dailyActivities": "እለታዊ ተግባራት",
      "pendingTasks": "በመጠባበቅ ላይ ያሉ ተግባራት",
      "performanceOfGeno": "የጂኖታይፕስ አፈጻጸም",
      "breed": "ዘር",
      "chromosome": "ክሮሞዞም",
      "seqChange": "ቅደም ተከተል ለውጥ",
      "inheritance": "ውርስ",
      "diseaseName": "የበሽታ ስም",
      "refSequence": "የማጣቀሻ ቅደም ተከተል",
      "pubmedRef": "የታተመ ማጣቀሻ",
      "matingDate": "የጋብቻ ቀን",
      "inseminatorName": "አስመጪ ስም",
      "orgName": "የድርጅት ስም",
      "brServiceNum": "የመራቢያ አገልግሎት ቁጥር",
      "conceptionMethod": "የፅንሰ-ሀሳብ ዘዴ",
      "semEmbInfo": "የዘር / የፅንስ መረጃ",
      "sireId": "የሲር መታወቂያ",
      "damID": "ግድብ መታወቂያ",
      "srgDamId": "ምትክ ግድብ መታወቂያ",
      "embOrgName": "ፅንሱ ኦርጅናል. ",
      "srgDamBreed": "ምትክ ግድብ ዝርያ",
      "sireBreed": "ሲር ዘር",
      "damBreed": "ግድብ ዘር"
    },
    "user": {
      "selectLanguage": "ቋንቋ ይምረጡ",
      "unitPreference": "የክፍል ምርጫ",
      "selectUnitOfMeasure": "የመለኪያ አሃድ ይምረጡ",
      "importedUser": "ከውጭ የመጣ ተጠቃሚ",
      "impFileStatus": "የፋይል ሁኔታን አስመጣ",
      "loadingUser": "ተጠቃሚዎችን በመጫን ላይ... እባክዎ ይጠብቁ",
      "totalUsers": "አጠቃላይ ተጠቃሚዎች",
      "pendingUsers": "በመጠባበቅ ላይ ያሉ ተጠቃሚዎች",
      "changePassword": "የሚስጥር ቁልፍ ይቀይሩ",
      "goodIdeaToUsePassword": "ሌላ ቦታ የማይጠቀሙትን ጠንካራ የይለፍ ቃል መጠቀም ጥሩ ሀሳብ ነው።",
      "enterCurrentPassword": "የአሁኑን የይለፍ ቃል ያስገቡ",
      "enterNewPassword": "አዲስ የይለፍ ቃል ያስገቡ",
      "reEnterPassword": "አዲስ የይለፍ ቃል እንደገና አስገባ",
      "enterPassword": "የይለፍ ቃል ያስገቡ",
      "repeatNewPassword": "አዲስ የይለፍ ቃል ድገም",
      "emailAddr": "የ ኢሜል አድራሻ",
      "enterYourPhoneNumber": "ስልክ ቁጥርዎን ያስገቡ",
      "pleaseTypeOldPassword": "እባክህ የድሮ የይለፍ ቃል ጻፍ።",
      "pleaseTypeNewPassword": "እባክዎ አዲስ የይለፍ ቃል ይተይቡ።",
      "pleaseTypeConfirmPassword": "እባክህ አረጋግጥ የይለፍ ቃል ጻፍ።",
      "passwordChangedSuccesFully": "የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል።",
      "currentPassword": "የአሁኑ ሚስጥራዊ ማለፊያ ቁልፍ",
      "newPassword": "አዲስ የይለፍ ቃል",
      "passwordDoesNotMatch": "የይለፍ ቃሎች አይዛመዱም።",
      "emailCanNotBeEmpty": "ኢሜል ባዶ ሊሆን አይችልም።",
      "profileUpdated": "መገለጫ ተዘምኗል",
      "profileNotUpdated": "መገለጫ አልዘመነም።",
      "unableToVerifyEmail": "ኢሜል ማረጋገጥ አልተቻለም",
      "otpSentOnEmail": "OTP በኢሜል ተልኳል።",
      "otpSentSuccessFully": "OTP በተሳካ ሁኔታ ተልኳል።",
      "importUsers": "ተጠቃሚዎችን አስመጣ",
      "imageUpdated": "ምስል ተዘምኗል",
      "departmentName": "የመምሪያው ስም",
      "departmentNum": "የመምሪያው ቁጥር",
      "departmentAdded": "መምሪያ ታክሏል",
      "departmentNotAdded": "ክፍል አልተጨመረም።",
      "searchDepartnment": "በመምሪያው ስም ወይም ቁጥር ይፈልጉ",
      "addDepartMent": "ዲፓርትመንት አክል",
      "addDepartment": "ዲፓርትመንት አክል",
      "roleNameIsRequired": "የሚና ስም ያስፈልጋል",
      "roleNameMustBeLessThan15Chars": "የሚና ስም ከ15 ቁምፊዎች ያነሰ መሆን አለበት።",
      "roleAdded": "ሚና ታክሏል።",
      "editDepartment": "ክፍል አርትዕ",
      "departmentUpdated": "መምሪያ ዘምኗል",
      "departmentNotUpdated": "መምሪያ አልዘመነም።",
      "deleteDepartment": "መምሪያን ሰርዝ",
      "deleteDepartmentMessage": "እርግጠኛ ነዎት ይህን ክፍል መሰረዝ ይፈልጋሉ።",
      "noRoleAvailable": "ምንም ሚና አይገኝም",
      "roleUpdated": "ሚና ተዘምኗል",
      "roleNotUpdated": "ሚና አልዘመነም።",
      "editRole": "ሚናን ያርትዑ",
      "allRole": "ሁሉም ሚና",
      "addNewRole": "አዲስ ሚና ጨምር",
      "allDepartment": "ሁሉም መምሪያ",
      "permissionsUpdated": "ፈቃዶች ተዘምነዋል",
      "permissionsnotUpdated": "ፈቃዶች አልተዘመኑም።",
      "roleNo": "ሚና ቁጥር",
      "searchByEmailAndName": "በኢሜል እና በስም ይፈልጉ",
      "userID": "የተጠቃሚው መለያ",
      "userUpdated": "ተጠቃሚ ተዘምኗል",
      "userNotUpdated": "ተጠቃሚ አልዘመነም።",
      "userAdded": "ተጠቃሚ ታክሏል።",
      "userNotAdded": "ተጠቃሚ አልታከለም።",
      "activateUser": "ተጠቃሚን አንቃ",
      "deactivateUser": "ተጠቃሚን አቦዝን",
      "userStatusMsg": "እርግጠኛ ነዎት የተጠቃሚውን ሁኔታ መቀየር ይፈልጋሉ",
      "countryRequired": "ሀገር ያስፈልጋል",
      "stateRequired": "ግዛት ያስፈልጋል",
      "cityRequired": "ከተማ ያስፈልጋል",
      "searchByRole": "በሚና ቁጥር፣ በሚና ስም፣ በመምሪያው ይፈልጉ",
      "noModuleAvailable": "ምንም ሞጁል የለም።",
      "searchBYModuleName": "በሞጁል ስም ይፈልጉ"
    },
    "farm": {
      "farmID": "የእርሻ መታወቂያ",
      "onTheFarm": "በእርሻ ላይ",
      "userRoles": "የተጠቃሚ ሚናዎች",
      "adduser": "ተጠቃሚ አክል",
      "addAuser": "ተጠቃሚ ያክሉ",
      "uploadUsers": "ተጠቃሚዎችን ጫን",
      "addNewUser": "አዲስ ተጠቃሚ ያክሉ",
      "selectDept": "ክፍል ይምረጡ",
      "selectRole": "ሚና ይምረጡ",
      "editUser": "ተጠቃሚን ያርትዑ",
      "totalFarms": "ጠቅላላ እርሻዎች",
      "NoAnimalsRegisteredForthisFarm": "ለዚህ እርሻ ምንም እንስሳት አልተመዘገቡም።",
      "farmsPerPage": "እርሻዎች በገጽ",
      "regularFarms": "መደበኛ እርሻዎች",
      "farmRegisteredProducts": "በእርሻ የተመዘገቡ ምርቶች",
      "searchByFarmNameAndId": "በእርሻ ስም እና መታወቂያ ይፈልጉ",
      "loadingProductsPleaseWait": "ምርቶችን በመጫን ላይ... እባክዎ ይጠብቁ",
      "farmName": "የእርሻ ስም",
      "farmLocation": "የእርሻ ቦታ",
      "productName": "የምርት ስም",
      "stockStatus": "የአክሲዮን ሁኔታ",
      "inStock": "ለሽያጭ የቀረበ እቃ",
      "searchByProductName": "በምርት ስም ይፈልጉ",
      "productCategory": "የምርት ምድብ",
      "products": "ምርቶች",
      "farms": "እርሻዎች",
      "registerAfarm": "እርሻ ይመዝገቡ",
      "govtRegistry": "መንግስት ",
      "cooperativeID": "የትብብር መታወቂያ",
      "farmType": "የእርሻ ዓይነት",
      "contractMating": "ኮንትራት ማዛመድ",
      "customization": "ማበጀት",
      "recordsPerpage": "መዝገቦች በገጽ",
      "restoreDefault": "ነባሪ እነበረበት መልስ",
      "apply": "ያመልክቱ",
      "searchState": "በእርሻ መታወቂያ፣ በመንግስት መዝገብ ቤት፣ በመተባበር መታወቂያ፣ የእርሻ ዓይነት፣ የኮንትራት ማዛመድን ይፈልጉ",
      "farmOwner": "የእርሻ ባለቤት",
      "govRegistrationNo": "የመንግስት ምዝገባ ቁጥር",
      "farmInformation": "የእርሻ መረጃ",
      "ownershipType": "የባለቤትነት አይነት",
      "communityName": "የማህበረሰብ ስም",
      "farmLicenseInformation": "የእርሻ ፈቃድ መረጃ",
      "licenseNumber": "የፍቃድ ቁጥር",
      "licenseExpiryDate": "የፍቃድ ጊዜው የሚያበቃበት ቀን",
      "regulatorName": "የቁጥጥር ስም",
      "regulatorRepresentativeName": "ተቆጣጣሪ ተወካይ ስም",
      "farmLocationSize": "የእርሻ ቦታ",
      "productionSystem": "የምርት ስርዓት",
      "country": "ሀገር",
      "state": "ግዛት",
      "city": "ከተማ",
      "street": "ጎዳና",
      "houseNumber": "የቤት ቁጥር",
      "farmRegistration": "የእርሻ ምዝገባ",
      "cancel": "ሰርዝ",
      "register": "ይመዝገቡ",
      "ok": "እሺ",
      "totalFarmSize": "ጠቅላላ የእርሻ መጠን",
      "farmGeographicLocation": "የእርሻ ጂኦግራፊያዊ አካባቢ",
      "perimeterPointLongitude": "የፔሪሜትር ነጥብ ኬንትሮስ",
      "perimeterPointLatitude": "የፔሪሜትር ነጥብ ኬክሮስ",
      "perimeterPointLabel": "የፔሪሜትር ነጥብ መለያ",
      "perimeterLength": "የፔሪሜትር ርዝመት",
      "farmLatitude": "የእርሻ ኬክሮስ",
      "farmLongitude": "የእርሻ ኬንትሮስ",
      "editFarm": "እርሻ አርትዕ",
      "update": "አዘምን",
      "editAfarm": "አንድ እርሻ አርትዕ",
      "nextFarm": "ቀጣይ እርሻ",
      "nameoftheFarm": "የእርሻው ስም",
      "registerAProduct": " አንድ ምርት ይመዝገቡ",
      "farmProducts": "የእርሻ ምርቶች",
      "calf": "ጥጃ",
      "steer": "መምራት",
      "heifer": "ጊደር",
      "sire": "ሳይሬ",
      "dam": "ግድብ",
      "registerAnAnimal": "አንድ እንስሳ ይመዝገቡ",
      "farmAnimals": "የእርሻ እንስሳት",
      "farm_type": "የእርሻ ዓይነት",
      "farm_Owner": "የእርሻ-ባለቤት",
      "dateOfRegistration": "የምዝገባ ቀን",
      "dataIsNotAvailableForThisFarm": "ውሂብ ለዚህ እርሻ አይገኝም",
      "registerNewProduct": "አዲስ ምርት ይመዝገቡ",
      "information": "መረጃ",
      "licenseInfo": "የፍቃድ መረጃ",
      "locationInfo": "የአካባቢ መረጃ",
      "geoLocation": "ጂኦ አካባቢ",
      "perimeterLengthState": "የእርሻ ፔሪሜትር ርዝመት (የአጥር ርዝመት)",
      "totalFarmSizeState": "የእርሻ መጠን",
      "productionSystemState": "በእርሻ ውስጥ ጥቅም ላይ የዋለው የምርት ስርዓት",
      "contractMatingState": "እርሻው የሚሳተፍበት የኮንትራት ማዛመጃ ፕሮግራም ኮድ.",
      "ownershipTypeState": "የባለቤትነት አይነት",
      "regulatorRepresentativeNameState": "ፈቃዱን ያወጣው ተቆጣጣሪን የሚወክል ሰው ስም",
      "regulatorNameState": "ፈቃዱን የለቀቀው የቁጥጥር ስም",
      "licenseExpiryDateState": "የአሁኑ ፈቃድ ጊዜው የሚያበቃበት ቀን",
      "licenseNumberState": "የፍቃድ ቁጥር በአስተዳዳሪ ተለቋል",
      "plotNumberState": "የእርሻው የቤት ቁጥር.",
      "plotNumber": "የቤት / ሴራ ቁጥር",
      "streetStatement": "የእርሻው የመንገድ ስም.",
      "cityStatement": "እርሻው የሚገኝበት ከተማ።",
      "stateStatement": "እርሻው የሚገኝበት የአገሪቱ ክልል.",
      "countryState": "እርሻው የሚገኝበት አገር.",
      "perimeterPointLongitudeState": "በእርሻ ላይ የአንድ ነጥብ ኬንትሮስ.",
      "perimeterPointLatitudeState": "በእርሻ ላይ የአንድ ነጥብ ኬክሮስ።",
      "perimeterPointLabelState": "የነጥብ መለያ።",
      "farmLongitudeState": "የእርሻው ኬንትሮስ.",
      "farmLatitudeState": "የእርሻው ኬክሮስ.",
      "farmNameH": "የእርሻ ስም",
      "farmTypeH": "የተለያዩ ተግባራት የሚከናወኑበት የእርሻ ዓይነት.",
      "farmOwnerH": "የእርሻ ባለቤት ስም (በራስ-ሰር የገበሬ ስም መግቢያ መረጃ)",
      "ownershipTypeH": "የሚያርሱትን መሬት በባለቤትነት የሚቆጣጠሩት እና የሌላቸው የገበሬዎች አይነት።",
      "govtRegNumbH": "በአስተዳዳሪው የተመደበው የእርሻ መመዝገቢያ ቁጥር",
      "contractMatingH": "እርሻው የሚሳተፍበት የኮንትራት ማዛመጃ ፕሮግራም ኮድ",
      "productionSystemH": "በእርሻ ላይ የምርት ስርዓቱ ምን ጥቅም ላይ ይውላል",
      "cooperativeIDH": "እርሻው አባል የሆነበት የህብረት ሥራ ማህበር መታወቂያ ",
      "licenseNumberH": "ከባለቤቱ ጋር በሚለይ ተቆጣጣሪ በተለቀቀ ፈቃድ ላይ መለያ ቁጥር።",
      "licenseExpiryDateH": "የአሁኑ ፈቃድ ጊዜው የሚያበቃበት ቀን",
      "regularNameH": "ፈቃዱን የለቀቀው የቁጥጥር ስም",
      "regularRepName": "ፈቃዱን ያወጣው ተቆጣጣሪን የሚወክል ሰው ስም",
      "countryH": "እርሻው የሚገኝበት አገር.",
      "stateH": "እርሻው የሚገኝበት የአገሪቱ ክልል.",
      "cityH": "እርሻው የሚገኝበት ከተማ።",
      "streetH": "የእርሻው የመንገድ ስም.",
      "houseNumberH": "የእርሻው የቤት ቁጥር.",
      "totalFarmSizeH": "የእርሻ መጠን በአሁኑ ጊዜ በእርሻ የሚለማው መሬት ድምር ነው, ነገር ግን በተፈጥሮ እፅዋት, በዛፎች ወይም በግጦሽ ስር ያለ መሬት ሳይጨምር በቆሻሻ መሬት ላይ ያለ መሬትን ጨምሮ.",
      "farmLatitudeH": "የርቀት መለኪያ ከምድር ወገብ በስተሰሜን ወይም በደቡብ ነው። ",
      "farmLongitudeH": "ከፕራይም ሜሪድያን በምስራቅ ወይም በምዕራብ ያለውን ርቀት ይለካል።",
      "perimeterLengthH": "የእርሻ ቦታዎች ርዝመት (የአጥር ርዝመት)",
      "perimeterPointLabelH": "የነጥብ መለያ። ",
      "perimeterPointLatH": "በእርሻ ላይ የአንድ ነጥብ ኬክሮስ",
      "perimeterPointLongH": "በእርሻ ላይ የአንድ ነጥብ ኬንትሮስ",
      "noProductAvailable": "ምንም ምርት አይገኝም",
      "farmUpdated": "እርሻ ተዘምኗል",
      "performance": "አፈጻጸም",
      "milkInformation": "የወተት መረጃ",
      "farmNameRequired": "የእርሻ ስም ያስፈልጋል"
    },
    "login": {
      "welcome": "እንኳን ደህና መጣህ! ",
      "welInfo": "ምስክርነቶችዎን ያስገቡ።",
      "login": "ግባ",
      "forgotPassword": "መክፈቻ ቁልፉን ረሳኽው",
      "forgotPasswordDesc": "እባክዎ ከመለያዎ ጋር የተያያዘውን የኢሜይል አድራሻ ያስገቡ። ",
      "backToLogin": "ወደ Login ተመለስ"
    },
    "actionListmod": {
      "actionList": "የድርጊት ዝርዝር",
      "tODAY": "ዛሬ",
      "createTask": "ተግባር ፍጠር",
      "myActivities": "የእኔ እንቅስቃሴዎች",
      "jhonSmith": "ጆን ስሚዝ",
      "farmID": "የእርሻ መታወቂያ",
      "dateOfEvent": "የዝግጅቱ ቀን",
      "actionRequired": "እርምጃ ያስፈልጋል",
      "actionTaken": "እርምጃ ተወሰደ",
      "animalEventID": "የእንስሳት ክስተት መታወቂያ",
      "cANCEL": "ሰርዝ",
      "cONFIRM": "አረጋግጥ",
      "sTATEMENT": "እርግጠኛ ነዎት ይህን መዝገብ መሰረዝ ይፈልጋሉ?",
      "dAY": "ቀን",
      "wEEK": "ሳምንት",
      "mONTH": "ወር",
      "sUBMIT": "አስገባ",
      "startDate": "የመጀመሪያ ቀን",
      "endDate": "የመጨረሻ ቀን",
      "rEPEAT": "ይድገሙ",
      "taskCategory": "የተግባር ምድብ",
      "pRIORITY": "ቅድሚያ",
      "aSSIGNEE": "ተመዳቢ",
      "selectLocation": "ቦታ ይምረጡ",
      "selectAnimals": "አንድ ወይም ከዚያ በላይ እንስሳትን ይምረጡ",
      "dESCRIPTION": "መግለጫ",
      "customRecurrence": "ብጁ ተደጋጋሚነት",
      "repeatEvery": "እያንዳንዱን ይድገሙት",
      "taskName": "የተግባር ስም",
      "enterDescription": "መግለጫ አስገባ",
      "toDo": "ለመስራት",
      "assignTo": "መድብ ለ",
      "status": "ሁኔታ",
      "nOTE": "ማስታወሻ",
      "noTaskAvailable": "ምንም ተግባር አይገኝም",
      "healthRecord": "የጤና መዝገብ",
      "iD": "መታወቂያ",
      "tAG": "መለያ",
      "dateOfbirth": "የተወለደበት ቀን",
      "taskTakenat": "የተከናወነው ተግባር",
      "gENDER": "ጾታ",
      "bREED": "ዘር",
      "regDate": "ሬጅ. ",
      "updateHealthRecord": "ለእንስሳት የጤና መዝገብ ያዘምኑ",
      "treatment": "ሕክምና",
      "reasonOftreatment": "የሕክምናው ምክንያት",
      "treatmentDate": "የሕክምና ቀን",
      "dIAGNOSIS": "ምርመራ",
      "drugId": "የመድሃኒት መታወቂያ",
      "drugName": "የመድሃኒት ስም",
      "drugWithdrawalperiod": "የመድኃኒት ማስወገጃ ጊዜ",
      "attendingVeterinarian": "የእንስሳት ሐኪም መገኘት",
      "packId": "የጥቅል መታወቂያ",
      "noItemsselected": "ምንም ንጥል አልተመረጡም።",
      "healthRecordsubmission": "የጤና መዝገብ ማስገባት",
      "inseminationRecordsubmission": "የማዳቀል-መመዝገብ ግቤት",
      "inseminatorName": "አስመጪ ስም",
      "inseminatorId": "ኢንሴሚናተር መታወቂያ",
      "conceptionRate": "የፅንሰ-ሀሳብ መጠን",
      "dateOfmeasurement": "የሚለካበት ቀን",
      "recordSubmission": "መዝገብ ማስገባት",
      "uPDATE": "አዘምን",
      "updateTask": "ተግባርን አዘምን"
    },
    "inseminatorStatisticsInfo": {
      "addInseminatorInfo": "አስመጪ መረጃን ያክሉ",
      "inseminatorNumber": "አስመጪ ቁጥር",
      "loadingInseminatorPleaseWait": "ኢንሴሚናተርን በመጫን ላይ... እባክዎ ይጠብቁ",
      "searchByIDAndName": "በመታወቂያ እና በስም ይፈልጉ",
      "inseminatorInfoAdded": "አስመጪ መረጃ ታክሏል።",
      "inseminatorInfoNotAdded": "አስመጪ መረጃ አልተጨመረም።",
      "inseminatorInfoUpdated": "አስመጪ መረጃ ተዘምኗል",
      "inseminatorInfoNotUpdated": "አስመጪ መረጃ አልዘመነም።",
      "editAInseminatorInfo": "አስመጪ መረጃን ያርትዑ",
      "inseminatorList": "አስመጪዎች ዝርዝር",
      "inseminatorInfoDetails": "አስመጪ መረጃ ዝርዝሮች",
      "updateInseminatorInfo": "የአስተዳዳሪ መረጃን ያዘምኑ"
    },
    "organizationNtrInfo": {
      "loadingOrdersPleaseWait": "ትዕዛዞችን በመጫን ላይ... እባክዎ ይጠብቁ",
      "addStocks": "አክሲዮኖችን ይጨምሩ",
      "addStock": "አክሲዮን ጨምር",
      "quantity": "ብዛት",
      "selectUnit": "ክፍል ይምረጡ",
      "farmProducts": "የእርሻ ምርቶች",
      "cost": "ወጪ",
      "transactionID": "የግብይት መታወቂያ",
      "recipientID": "የተቀባይ መታወቂያ",
      "orderID": "የትዕዛዝ መታወቂያ",
      "recepientName": "ተቀባይ ስም",
      "createAOrder": "ትዕዛዝ ይፍጠሩ",
      "totalStocks": "ጠቅላላ አክሲዮኖች",
      "orders": "ትዕዛዞች",
      "totalPending": "ጠቅላላ በመጠባበቅ ላይ",
      "totalDelivered": "ጠቅላላ ደርሷል",
      "searchByRecepientNameOrderIdRecepientId": "በተቀባዩ ስም ፣ የትዕዛዝ መታወቂያ ፣ የተቀባይ መታወቂያ ይፈልጉ",
      "chooseTheDate": "ቀኑን ይምረጡ",
      "transactionDate": "የግብይት ቀን",
      "selectCategory": "ምድብ ይምረጡ",
      "volumeOfProduct": "የምርት መጠን",
      "productQuantity": "የምርት ብዛት",
      "productRecipientId": "የምርት ተቀባይ መታወቂያ",
      "productRecipientName": "የምርት ተቀባይ ስም",
      "productRecipientType": "የምርት ተቀባይ አይነት",
      "singleProduct": "ነጠላ ምርት",
      "orderPlaced": "ታዟል",
      "orderNotPlaced": "ትዕዛዝ አልተቀመጠም።",
      "totalPrice": "ጠቅላላ ዋጋ",
      "currency": "ምንዛሪ",
      "selectCurrency": "ምንዛሪ ይምረጡ",
      "address": "አድራሻ",
      "enterAddress": "አድራሻ አስገባ",
      "attachments": "አባሪዎች",
      "chooseFile": "ፋይል ይምረጡ",
      "nameOfTheFarm": "የእርሻው ስም",
      "loremIpsumHasBeenTheIndustrySStandardDummyText": "ሎሬም ኢፕሱም ከ1500ዎቹ ጀምሮ ያልታወቀ ማተሚያ ከወሰደበት ጊዜ ጀምሮ የኢንደስትሪው መደበኛ ዱሚ ጽሑፍ ነው።",
      "billedTo": "ተከፍሏል።",
      "orderStatus": "የትዕዛዝ ሁኔታ",
      "selectStatus": "ሁኔታን ይምረጡ",
      "cadbury": "Cadbury",
      "totalAmount": "አጠቃላይ ድምሩ",
      "deliveryCharges": "የመላኪያ ክፍያዎች",
      "orderDetails": "የትዕዛዝ ዝርዝሮች",
      "deliveryOnTime": "በሰዓቱ ማድረስ",
      "productID": "የምርት መታወቂያ",
      "productRegistration": "የምርት ምዝገባ",
      "enterTheNameOfTheProduct": "የምርቱን ስም ያስገቡ",
      "nameOfTheProduct": "የምርት ስም",
      "productAdded": "ምርት ታክሏል።",
      "productNotAdded": "ምርት አልታከለም።"
    },
    "drug": {
      "dRUGS": "መድሃኒቶች",
      "registerAdrug": "መድሃኒት ይመዝገቡ",
      "sEARCH": "ፈልግ",
      "genericName": "አጠቃላይ ስም",
      "manufacturer": "አምራች",
      "distributor": "አከፋፋይ",
      "registrationDate": "የምዝገባ ቀን",
      "drugRegistration": "የመድሃኒት ምዝገባ",
      "drugInformation": "የመድሃኒት መረጃ",
      "packExpiration": "የጥቅል ማብቂያ",
      "drugId": "የመድኃኒት መታወቂያ",
      "drugName": "የመድሃኒት ስም",
      "drugGenericname": "የመድኃኒት አጠቃላይ ስም",
      "drugManufacturer": "የመድኃኒት አምራች",
      "distributorName": "የአከፋፋይ ስም",
      "drugRegistrationdate": "የመድሃኒት ምዝገባ ቀን",
      "nextDrug": "የሚቀጥለው መድሃኒት",
      "editDrug": "መድሃኒትን ያርትዑ",
      "updateDrug": "መድሃኒትን አዘምን",
      "deleteDrug": "መድሃኒቱን ሰርዝ",
      "noRecordfound": "ምንም መዝገብ አልተገኘም።",
      "addDrug": "መድሃኒት ጨምር",
      "statementDrug": "መድሃኒቱ ተሰርዟል።  ",
      "cANCEL": "ሰርዝ",
      "cONFIRM": "አረጋግጥ",
      "sTATEMENT": "እርግጠኛ ነዎት ይህን መዝገብ መሰረዝ ይፈልጋሉ?",
      "ok": " እሺ",
      "information": "መረጃ",
      "packOrder": "እሽግ ትዕዛዝ",
      "packPrescription": "የታሸገ ማዘዣ",
      "packReservation": "ጥቅል ቦታ ማስያዝ",
      "packLocation": "የማሸጊያ ቦታ",
      "drugDozedam": "ለግድም በቀን ውስጥ የመድሃኒት መጠን",
      "drugDozecalf": "በቀን ውስጥ የመድሃኒት መጠን ለካፍ",
      "drugFormate": "የመድሃኒት ቅርጽ",
      "drugDistributor": "መድሃኒት አከፋፋይ",
      "drugActiveingridents": "የመድኃኒት ንቁ ንጥረ ነገሮች",
      "drugSubstitutionId": "የመድኃኒት ምትክ መታወቂያ",
      "packId": "የጥቅል መታወቂያ",
      "packBatchNumber": "የጥቅል ቁጥር",
      "drugIdStatement": "የመድኃኒቱ ብዛት።",
      "drugNameSatement": "መድኃኒቱ የሚሸጥበት የታወጀው የምርት ስም።",
      "drugGenericnameStatement": "መድኃኒቱ የሚሸጥበት ማስታወቂያ ከወጣው የምርት ስም ይልቅ የመድኃኒቱ ኬሚካዊ ሜካፕ።",
      "drugFormateSatement": "የመድኃኒቱ ብዛት።",
      "drugDozecalfSatement": "የመድሃኒት መጠን ወደ ጥጃው መጠን ለማወቅ.",
      "drugDozedamStatement": "ለግድብ የመድሃኒት መጠን መጠን ለማወቅ.",
      "drugManufacturerStatement": "የመድኃኒት አምራች ዝርዝሮች.",
      "drugDistributorStatement": "የመድኃኒት አከፋፋይ ዝርዝሮች.",
      "drugRegistrationdateStatement": "በልዩ ሀገር ውስጥ የመድሃኒት ምዝገባ ቀን.",
      "drugActiveingridentsStatement": "የንቁ ንጥረ ነገሮች ዝርዝር.",
      "drugSubstitutionIdStatement": "ዋናው መድሃኒት በአሁኑ ጊዜ ሊገኝ በማይችልበት ሁኔታ ውስጥ ለመድኃኒቱ ሊተኩ የሚችሉ መታወቂያዎች።",
      "packIdStatement": "የማሸጊያው ባር ኮድ ወይም RF መታወቂያ።",
      "packBatchNumberStatement": "ለማሸጊያው በአምራቹ የተመደበው የቡድን ቁጥር.",
      "locationWarehouseID": "የመገኛ ቦታ የመጋዘን መታወቂያ",
      "locationWarehouseIDState": "ማሸጊያው የተከማቸበት መጋዘን መታወቂያ።",
      "locationRackID": "አካባቢ Rack መታወቂያ",
      "locationRackIDStatement": "ማሸጊያው የተከማቸበት የመደርደሪያ መታወቂያ።",
      "locationTierID": "የአካባቢ ደረጃ መታወቂያ",
      "locationTierIDStatement": "ማሸጊያው በሚከማችበት መደርደሪያ ላይ ያለው የደረጃ መታወቂያ።",
      "locationPositionID": "የአካባቢ አቀማመጥ መታወቂያ",
      "locationPositionIDStatement": "ማሸጊያው በሚከማችበት ደረጃ ላይ ያለው የቦታ መታወቂያ።",
      "storageTemperatureCondition": "የማከማቻ የሙቀት ሁኔታ",
      "storageTemperatureConditionStats": "እሽግ የማከማቸት ሁኔታ.",
      "containerForm": "የመያዣ ቅጽ",
      "containerFormStatement": "መድሃኒቱ የታሸገበት መያዣ ቅርጽ.",
      "consistQuantity": "ብዛትን ያቀፈ",
      "consistQuantityStatement": "በማሸጊያው ውስጥ ያሉ እንክብሎች፣ ጠርሙሶች፣ ወዘተ ብዛት።",
      "releaseId": "የመልቀቂያ መታወቂያ",
      "releaseIdStatement": "ማሸጊያው በገበሬው ከተወሰደ በኋላ የተመደበው መታወቂያ።",
      "releaseDate": "ይፋዊ ቀኑ",
      "releaseDateStatement": "ማሸጊያው በገበሬው ከአክሲዮን የተወሰደበት ቀን።",
      "packManufacturedDate": "ጥቅል የተሰራበት ቀን",
      "packManufacturedDateStatement": "ማሸጊያው የተመረተበት ቀን።",
      "packImportedDate": "ጥቅል የመጣበት ቀን",
      "packImportedDateStatement": "ማሸጊያው የገባበት ቀን።",
      "packExpirationDate": "የጥቅል ማብቂያ ቀን",
      "packExpirationDateStatement": "ጥቅሉ ጊዜው የሚያበቃበት ቀን።",
      "expiredSoonFlag": "በቅርቡ ጊዜው አልፎበታል ባንዲራ",
      "expiredSoonFlagState": "ስለ ማሸጊያው በቅርቡ ጊዜው ስለሚያልፍ ማስጠንቀቂያ።",
      "packTotalVolumeLeft": "የግራ ጥቅል ጠቅላላ ድምጽ",
      "packTotalVolumeLeftState": "በክምችት ውስጥ የቀሩት ተመሳሳይ ንጥረ ነገሮች ያላቸው የጥቅሎች ጠቅላላ ብዛት።",
      "packOrderID": "የትዕዛዝ መታወቂያ ጥቅል",
      "packOrderIDState": "ማሸጊያውን ከአከፋፋይ ካዘዘ በኋላ የተመደበ መታወቂያ።",
      "packQuantityOrdered": "የታሸገው ብዛት ታዝዟል።",
      "packQuantityOrderedState": "ከአከፋፋይ የታዘዙ የጥቅሎች ብዛት።",
      "packPrice": "የጥቅል ዋጋ",
      "packPriceStatement": "የጥቅል ዋጋ.",
      "priceCurrency": "የዋጋ ምንዛሬ",
      "packPricecurrency": "ጥቅል የዋጋ ምንዛሬ",
      "packPricecurrencyState": "ዋጋው በእጩነት የቀረበበት የምንዛሬ ስም።",
      "packPaydate": "የጥቅል ክፍያ ቀን",
      "payDate": "የሚከፈልበት ቀን",
      "packPaydateState": "ክፍያው ለአከፋፋዩ የተለቀቀበት ቀን።",
      "packShippingID": "የማጓጓዣ መታወቂያ ጥቅል",
      "shippingID": "የመላኪያ መታወቂያ",
      "packShippingIdState": "የማሸጊያው የማጓጓዣ መታወቂያ ከአከፋፋይ ሲደርስ።",
      "packShippingDate": "ጥቅል የመላኪያ ቀን",
      "shippingDate": "የመላኪያ ቀን",
      "packShippingDateState": "ማሸጊያው በክምችቱ ላይ የሚደርስበት ቀን።",
      "packOrderStatus": "የጥቅል ትዕዛዝ ሁኔታ",
      "packOrderStatusState": "የአሁኑ ትዕዛዝ ሁኔታ.",
      "recepientKeeperId": "የተቀባይ ጠባቂ መታወቂያ",
      "recepientKeeperIdStatement": "ማሸጊያውን የተቀበለው ግለሰብ/ድርጅት ስም።",
      "recepientFarmId": "የተቀባይ እርሻ መታወቂያ",
      "recepientFarmIdStatement": "የእንስሳት መድኃኒት ተቀባይ ያለበት የእርሻ መታወቂያ።",
      "recepientAnimalId": "የእንሰሳት መቀበያ መታወቂያ",
      "recepientAnimalIdState": "መድሃኒቱ (ጥቅል) የታዘዘለት የእንስሳት መታወቂያ።",
      "specialistComments": "የልዩ ባለሙያ አስተያየቶች",
      "specialistCommentsState": "ስለ መድሃኒት ማዘዣ የስፔሻሊስት/የእንስሳት ህክምና አስተያየቶች።",
      "specialistName": "የልዩ ባለሙያ ስም",
      "specialistNameState": "መድሃኒቱን ያዘዘው ስፔሻሊስት / የእንስሳት ሐኪም ስም.",
      "specialistID": "የልዩ ባለሙያ መታወቂያ",
      "specialistIDState": "መድሃኒቱን ያዘዘው ስፔሻሊስት/የእንስሳት ሐኪም መታወቂያ።",
      "reservedByKeeperId": "በጠባቂ መታወቂያ የተያዘ",
      "reservedByKeeperIdState": "ማሸጊያውን ያስያዘው ማን ጠባቂ መታወቂያ።",
      "reservedByFarmId": "በእርሻ መታወቂያ የተያዘ",
      "reservedByFarmIdState": "ማሸጊያው የተያዘለት የእርሻ መታወቂያ።",
      "reservationTimeoutDate": "የቦታ ማስያዣ ጊዜ ማብቂያ ቀን",
      "reservationTimeoutDateState": "ማሸጊያው ካልተገዛ ቦታ ማስያዣው የሚሰረዝበት ቀን።",
      "reservationTimeout": "የቦታ ማስያዣ ጊዜ አልቋል",
      "reservationTimeoutState": "ማሸጊያው ካልተገዛ ወይም ካልተወሰደ የቦታ ማስያዣው የሚጠፋው የሰዓታት ብዛት",
      "reservationDate": "የተያዙበት ቀን",
      "reservationDateState": "የማሸጊያው የተያዘበት ቀን።",
      "reservationStatus": "የቦታ ማስያዣ ሁኔታ",
      "reservationStatusState": "የማሸጊያው ቦታ ማስያዝ ሁኔታ። ",
      "loadingDrugsPleaseWait": "መድሃኒቶችን በመጫን ላይ... እባክዎ ይጠብቁ",
      "quantityOrder": "የብዛት ቅደም ተከተል",
      "keeperID": "የጠባቂ መታወቂያ",
      "timeoutDate": "ጊዜው ያለፈበት ቀን",
      "warehouseID": "የመጋዘን መታወቂያ",
      "rackID": "የራክ መታወቂያ",
      "tierID": "የደረጃ መታወቂያ",
      "positionID": "የአቀማመጥ መታወቂያ",
      "temperatureCondition": "የሙቀት ሁኔታ",
      "manufactureDate": "የምርት ቀን",
      "importedDate": "የመጣበት ቀን",
      "totalVolumeLeft": "ጠቅላላ ድምጽ ግራ"
    },
    "reports": {
      "myReports": "የእኔ ዘገባዎች",
      "satelliteReports": "የሳተላይት ሪፖርቶች",
      "weatherReports": "የአየር ሁኔታ ሪፖርቶች",
      "pregnancyAnalytics": "የእርግዝና ትንታኔ",
      "semenEmbroyAnalytics": "የዘር / የፅንስ ትንታኔ",
      "semenAnalytics": "የዘር ትንተና",
      "embryoAnalytics": "የፅንስ ትንታኔ",
      "calfAnalytics": "ጥጃ ትንታኔ",
      "milkProduction": "ወተት ማምረት",
      "totalMilkType": "ጠቅላላ የወተት ዓይነት",
      "totalAnimalAnalytics": "ጠቅላላ የእንስሳት ትንታኔ",
      "animalAnalytics": "የእንስሳት ትንታኔ",
      "analyticsAndReporting": "ትንታኔ እና ሪፖርት ማድረግ",
      "filterByCountry": "በአገር አጣራ",
      "filterByFarm": "በእርሻ አጣራ",
      "filterByRegion": "በክልል አጣራ",
      "filterByMonth": "በወር አጣራ",
      "filterByDate": "በቀን አጣራ",
      "filterByRole": "በሚና አጣራ",
      "filterByYear": "በአመት አጣራ",
      "filterByTrait": "በባህሪ አጣራ",
      "avgBreedingValue": "አማካይ የመራቢያ እሴት",
      "avgEconomicIndex": "አማካይ የኢኮኖሚ መረጃ ጠቋሚ",
      "breederReport": "የእርባታ ሪፖርት",
      "semenTransferDate": "የዘር ፈሳሽ የሚተላለፍበት ቀን",
      "semenEmbryoProductionReport": "የዘር / የፅንስ ምርት ሪፖርት",
      "semenProducts": "የዘር ፈሳሽ ምርቶች",
      "meatProducts": "የስጋ ምርቶች",
      "totalProducts": "ጠቅላላ ምርቶች",
      "semenEmbryoReport": "የዘር / የፅንስ ሪፖርት",
      "numOfStraws": "የዛፎች ብዛት",
      "collectionDate": "የስብስብ ቀን",
      "productionReport": "የምርት ሪፖርት",
      "receipientId": "የተቀባይ መታወቂያ",
      "embryoId": "የፅንስ መታወቂያ",
      "semenStrawId": "የዘር ፈሳሽ መታወቂያ",
      "dataScientist": "የውሂብ ሳይንቲስት",
      "dataScientistReport": "የውሂብ ሳይንቲስት ሪፖርት",
      "productReport": "የምርት ሪፖርት",
      "dairyProducts": "የእንስሳት ተዋጽኦ"
    },
    "genoPerformance": {
      "performanceOfGenoType": "የ GenoType አፈጻጸም",
      "addAGenoType": "GenoType ያክሉ",
      "breedName": "የዘር ስም",
      "chromosome": "ክሮሞዞም",
      "sequenceChange": "ቅደም ተከተል ለውጥ",
      "inheritance": "ውርስ",
      "diseaseName": "የበሽታ ስም",
      "referenceSequence": "የማጣቀሻ ቅደም ተከተል",
      "pubmedReference": "የታተመ ማጣቀሻ",
      "genoTypeRegistration": "GenoType ምዝገባ",
      "breed": "ዘር",
      "editAGenoType": "GenoType ያርትዑ",
      "editGenoType": "GenoTypeን ያርትዑ",
      "loadingGene": "ጄኖን በመጫን ላይ... እባክዎ ይጠብቁ",
      "geneTypeList": "GenoType ዝርዝር"
    },
    "reportings": {
      "conception": "ጽንሰ-ሀሳብ (የውሂብ ሳይንቲስት)",
      "performanceOfGenoData": "የጂኖታይፕ (የመረጃ ሳይንቲስት) አፈጻጸም",
      "totalInsemination": "ጠቅላላ የማዳቀል",
      "embryo": "ሽል",
      "animalVaccinationRecord": "የእንስሳት ክትባት መዝገብ",
      "dataNotAvailable": "ውሂብ ለዚህ እርሻ አይገኝም።",
      "pregnancyStatus": "የእርግዝና ሁኔታ",
      "healthReport": "የጤና ሪፖርት",
      "heavyMilk": "ከባድ ወተት",
      "standardMilk": "መደበኛ ወተት"
    },
    "sidebar": {
      "healthAnalytics": "የጤና ትንታኔ",
      "productionAnalytics": "የምርት ትንታኔ"
    },
    "epd": {
      "regNo": "Animal Reg No የተወሰኑ እንስሳትን ለመለየት እና ለመከታተል የሚደረገውን ሂደት የሚያረጋግጥ ምልክት ማድረጊያ ዘዴን በመጠቀም ለእንስሳ የሚሰጠው ልዩ ኮድ ነው።",
      "internationalID": "የእንስሳት ዓለም አቀፍ መታወቂያ",
      "location": "አገር / የእንስሳት መወለድ ክልል ",
      "animalName": "የእንስሳቱ መደበኛ ስም / ስያሜ",
      "gender": "የእንስሳት ጾታ (ወንድ/ሴት)",
      "additionalIDMethod": "እንስሳውን ለመለየት ምን ዓይነት ዘዴ ጥቅም ላይ ውሏል (ለምሳሌ ፣ የጆሮ መለያ ፣ ንቅሳት)",
      "damID": "የእንስሳት ግድብ መታወቂያ ወይም መመዝገቢያ ቁጥር - የእንስሳት ሴት ወላጅ/የወላጅ እናት ቁጥር መታወቂያ",
      "sireId": "የእንስሳት ወንድ ወላጅ መታወቂያ ወይም መመዝገቢያ ቁጥር፣ በተለይም ለመራቢያነት የሚቀመጠው በሬ ወይም ለሰው ሰራሽ ማዳቀል የሚውል የወንድ የዘር ፈሳሽ።",
      "dateOfBirth": "የእንስሳቱ የትውልድ ቀን.",
      "breederHerdCode": "የአርቢ መንጋ ኮድ በአብዛኛው የሚሰጠው በአርቢ ማኅበራት ነው።",
      "seasonofBirth": "የእንስሳት መወለድ ወቅት በወር ጠቢብ ውስጥ ተጠቅሷል",
      "birthYear": "እንስሳው የተወለደበት ዓመት",
      "birthManagementCode": "የወሊድ አስተዳደር ኮድ በአብዛኛው የቀረበው በተጠቃሚ/ገበሬ ነው።",
      "birthSex": "የእንስሳት ጾታ (ወንድ/ሴት)",
      "birthWeight": "የጥጃ ልደት ክብደት ",
      "primaryBreed": "የእንስሳቱ ዋና % የጄኔቲክ አስተዋጽዖ ",
      "secondaryBreed": "አነስተኛ % የእንስሳት የጄኔቲክ አስተዋፅዖ ",
      "breedComposition": "የዘር ቅንጅት መቶኛ የሚያመለክተው በግለሰብ እንስሳ ወይም የእንስሳት ቡድን ዘረመል ውስጥ ያሉ የተለያዩ ዝርያዎችን ተመጣጣኝ ውክልና ነው። ",
      "conceptionMethod": "እንስሳው እንዴት እንደተፀነሰ (ተፈጥሯዊ ማዳቀል/ማዳቀል/ፅንስ ማስተላለፍ)።",
      "accuracyWeight": "ትክክለኛ ክብደት",
      "damAge": "የግድቡ ዕድሜ በወራት/ዓመት ለምሳሌ. ",
      "weaningWeight": "ጡት በማጥባት ጊዜ የእንስሳት ክብደት።",
      "weaningDate": "እንስሳ ጡት የተጣለበት ቀን",
      "weaningSex": "ጡት የተጣለበት የእንስሳት ጾታ. ",
      "managementPastureCode": "ኮድ ለአስተዳደር/ግጦሽ በተጠቃሚ/ገበሬ ",
      "creep": "ክሪፕ መመገብ ተጨማሪ ምግብ (እህል ወይም መኖ) ለነርሲንግ ጥጃዎች የመስጠት ልምምድ ነው።",
      "weaningContemporaryGroupCode": "የጡት ማጥባት ክብደት ኮንቴምፖራሪ ቡድን",
      "birthContemporaryCode": "የዘመናዊ ልደት ኮድ",
      "yearlingDate": "የአንድ አመት የእንስሳት ቀን ወይም በእድሜው በሁለተኛው አመት",
      "managementFeedUnitCode": "ኮድ ለአስተዳደር/መጋቢ በተጠቃሚ የተሰጠ",
      "yearlingSex": "በዓመት ውስጥ የእንስሳቱ ጾታ ",
      "yearlingWeight": "አመታዊ ክብደት ከጡት ማጥባት በኋላ ቀጥተኛ እድገትን የሚለካ ሲሆን ብዙ ጊዜ በገበያ ላይ የተመሰረቱ ዘሮችን በመኖ ውስጥ ያለውን እምቅ አፈጻጸም ለማንፀባረቅ ይጠቅማል፣በሚለካ ጥጃ ፓውንድ።",
      "yearlingHeight": "በዓመት ውስጥ የእንስሳቱ ቁመት ",
      "yearlingWeightContemporaryGroupCode": "የዓመት ክብደት ኮንቴምፖራሪ ቡድን",
      "weaningYearlingWeightContemporaryGroupCode": "የጡት ማጥባት ወይም አመታዊ ክብደት ኮንቴምፖራሪ ቡድን",
      "daysOnFeed": "በዚያ ልዩ መኖ የተመገቡት የቀናት ብዛት ለምሳሌ፡ ወጣት የሚበቅሉ ከብቶች በአነስተኛ ዋጋ ለገበያ የሚቀርብ የበሬ ሥጋ ለማምረት ከፍተኛ ኃይል ባለው አመጋገብ ይመገባሉ። ",
      "managementFeedUnitPenCode": "ኮድ ለአስተዳደር/የመጋቢ ክፍል/በተጠቃሚ የተሰጠ",
      "harvestDate": "ለስጋ የታረደ (የተገደለ) እንስሳ ቀን",
      "gradingDate": "የሬሳዎች ቀን በተወሰነ መስፈርት መሰረት ተሰጥቷል",
      "carcassSex": "የአስከሬን ወሲብ",
      "dateonFeed": "እንስሳው ወደ አዲስ መኖ የተሸጋገረበት ቀን ለምሳሌ፡ ወጣት ከብቶች በአነስተኛ ዋጋ ለገበያ የሚቀርብ የበሬ ሥጋ ለማምረት ከፍተኛ ኃይል ባለው አመጋገብ ይመገባሉ። ",
      "KPH": "% KPH በተለይ በኩላሊት፣ በዳሌ እና በልብ አካባቢዎች በሬሳ የሰውነት ክፍተት ውስጥ የሚገኘው የጠቅላላ ስብ መቶኛ ነው። ",
      "carcassWeight": "የካርኬጅ ክብደት ከተሰበሰበ በኋላ እና ቆዳን, ጭንቅላትን, የጨጓራና ትራክት እና የውስጥ አካላትን ማስወገድ ሞቃት ወይም ያልቀዘቀዘ ክብደት ነው. ",
      "fatThickness": "የስብ ውፍረት የሚለካው በትንሽ ገዢ በመጠቀም ኢንች ነው። ",
      "marbling": "ማርሊንግ በጡንቻ ውስጥ እና በጡንቻ ፋይበር እሽጎች መካከል የሚከማች የሚታየው ያልተሟላ (ጤናማ) ጡንቻማ ስብ ነው።",
      "ribeyeArea": "በ 12 ኛ እና 13 ኛ የጎድን አጥንቶች መካከል የሚለካው የጎድን-ዓይን መጠን (ለምሳሌ ፣ 8 ፣ 9 ወይም 10 ኢንች) በመጠቀም በካሬ ኢንች (ለምሳሌ ፣ 8 ፣ 9 ወይም 10 ኢንች) መካከል። ",
      "animalStatus": "በእርሻ ውስጥ የእንስሳት ሁኔታ ለምሳሌ: ጤናማ, የታመመ, ወዘተ"
    },
    "manageAnimalGroupings": {
      "resetModeTooltip": "\n        ሁነታን ዳግም አስጀምር <br>\n            በዚህ ሁነታ <br>\n            1) ለሁሉም የፍላጎት ባህሪያት ሁሉንም ወቅታዊ ቡድኖችን (CGs) ባህሪያትን አዘጋጅ / መግለፅ. <br>\n            2) ሁሉንም እንስሳት ለተዛማጅ CG መድብ። <br>\n            3) የእንስሳት መመደብ አጥጋቢ ካልሆነ ፣ሲጂዎችን አስተካክል/መቀየር እና እንስሶቹን እንደገና ወደ አዲስ ተዛማጅ CGs መድብ። <br>\n            4) አስፈላጊ ከሆነ የ CG ዎችን እና የእንስሳትን መቧደን / መመደብ እስኪያሟሉ ድረስ ከላይ ያሉትን እርምጃዎች ይድገሙ።<br>\n        ",
      "maintainanceModeHeadingTooltip": "አንዴ ዳግም አስጀምር (ሁነታ) ከተጠናቀቀ፣ በዳግም ማስጀመሪያው ላይ የሚሰሉት ኢዲፒዎች ለእያንዳንዱ እንስሳ እስከሚቀጥለው ዳግም ማስጀመር ድረስ የሚቆዩበትን የMaNTENANCE MODE ያስገባሉ (ይህም ከ2-6 ወራት ሊቀረው ይችላል)። ",
      "maintainanceModeTooltip": "የዳግም ማስጀመሪያ ሁነታውን ከጨረሱ በኋላ ስርዓቱ የሁሉም እንስሳት ኢፒዲዎችን ለማስላት፣ የዳግም ማስጀመሪያ ሁነታን ያቋርጡ እና የMANTENANCE MODE ን ለማስጀመር የዳግም አስጀምር FINALIZED ቁልፍን ይጫኑ።",
      "resetToggleTooltip": "እንስሳትን ለCGs ለመመደብ በEPD ሞዴል ቅንብር ውስጥ ዳግም ማስጀመርን አንቃ።"
    },
    "geneticsAndBreeding": {
      "geneticsAndBreeding": "ጀነቲክስ",
      "geneticSearchTool": "የጄኔቲክ ፍለጋ መሳሪያ",
      "dataSubmission": "የውሂብ ማስገባት / የእንስሳት ምርጫ",
      "animalsWithExpectedProgenyDifferences": "ለሚጠበቁ የዘር ልዩነቶች (ኢፒዲዎች) ስሌት የእንስሳት ምርጫ",
      "searchByAnimalIdName": "በእንስሳት መታወቂያ፣ ስም ይፈልጉ",
      "rowsPerPage": "ረድፎች በገጽ",
      "individualEntry": "የግለሰብ መግቢያ",
      "bulkEntry": "የጅምላ ማስገቢያ",
      "registerANewAnimalOrSelectAnExistingAnimal": "አዲስ እንስሳ ይመዝገቡ ወይም ነባር እንስሳ ይምረጡ።",
      "registerNewAnimal": "አዲስ እንስሳ ይመዝገቡ",
      "selectExistingAnimal": "ነባሩን እንስሳ ይምረጡ",
      "animalID": "የእንስሳት መታወቂያ",
      "animalName": "የእንስሳት ስም",
      "tag": "መለያ",
      "dateOfBirth": "የተወለደበት ቀን",
      "gender": "ጾታ",
      "birthDate": "የልደት ቀን",
      "birthWeightLb": "የልደት ክብደት (ፓውንድ)",
      "birthWeightKg": "የልደት ክብደት (ኪግ)",
      "weaningWeightLb": "የጡት ማጥባት ክብደት (ፓውንድ)",
      "weaningWeightKg": "የጡት ማጥባት ክብደት (ኪግ)",
      "yearlingWeightLb": "አመታዊ ክብደት (ፓውንድ)",
      "yearlingWeightKg": "አመታዊ ክብደት (ኪግ)",
      "carcassWeightLb": "የሬሳ ክብደት (ፓውንድ)",
      "carcassWeightKg": "የሬሳ ክብደት (ኪግ)",
      "animalSelection": "የእንስሳት ምርጫ",
      "animalSearchTool": "የእንስሳት ፍለጋ መሳሪያ",
      "back": "ተመለስ",
      "searchByEPDs": "በEPDs ይፈልጉ",
      "searchByIds": "በመታወቂያዎች ይፈልጉ",
      "selectBreed": "ዘር ይምረጡ",
      "selectGender": "ጾታን ይምረጡ",
      "selectRequiredBreedForCattle": "ለከብቶች አስፈላጊውን ዘር ይምረጡ",
      "resetFilter": "ማጣሪያን ዳግም አስጀምር",
      "birthWeightHeader": "የልደት ክብደት(BW)፦ ",
      "birthWeightDef": "በወሊድ ጊዜ የጥጃዎችን ክብደት ልዩነት ያወዳድራል እና በክብደት ወይም በኪ.ግ.",
      "weaningWeightHeader": "የጡት ማጥባት ክብደት (WW): ",
      "weaningWeightDef": "WW EPD በክብደት ወይም በኪግ የሚለካ የቅድመ-ጡት ማጥባት እድገት ግምት ነው።",
      "yearlingWeightHeader": "አመታዊ ክብደት (YW)፦ ",
      "yearlingWeightDef": "YW EPD በክብደት ወይም በኪሎ የሚለካ የድህረ-ጡት ማደግ ግምት ነው።",
      "ribEyeAreaHeader": "ሪቤይ አካባቢ(REA)፦ ",
      "ribEyeAreaDef": "REA ሪቤይ የሚሰጠንን የጡንቻ መጠን በካሬ ኢንች ይለካል።REA EPDs በተስተካከለ የ365-ቀን የሪቤዬ አካባቢ መለኪያ ላይ በተሰበሰቡ ከብቶች አስከሬን መለካት ላይ ልዩነቶችን ያንፀባርቃሉ።",
      "marblingHeader": "ማርሊንግ(MARB)፦ ",
      "marblingDef": "የMARB EPD በሪቤዬ ውስጥ ባለው የጡንቻ ውስጥ ውፍረት መቶኛ አሃዶች ውስጥ ነው።MARB EPDs በተሰበሰቡ የከብቶች ሬሳ መለኪያዎች ላይ በመመስረት በተስተካከለ የ365-ቀን የእብነ በረድ ነጥብ (የጡንቻ ጡንቻ ስብ፣ አይኤምኤፍ) ላይ ልዩነቶችን ያንፀባርቃሉ።",
      "fatThicknessHeader": "የስብ ውፍረት(FAT): ",
      "fatThicknessDef": "የጀርባ ስብ (በመቶኛ ኢንች) የኤፍቲ መለኪያ አሃድ ነው።",
      "carcassWeightHeader": "የሬሳ ክብደት(CW)፦ ",
      "carcassWeightDef": "ፓውንድ ከመጨረሻው የምርት ዋጋ አንጻር ያለውን ተፅዕኖ ግምት ውስጥ በማስገባት የካርካስ ክብደት ጠቃሚ ባህሪ ነው። ",
      "yieldGradeHeader": "የምርት ውጤት (YG)፦ ",
      "yieldGradeDef": "የUSDA ምርት ውጤት ውጤት ስርዓት የYG EPD መለኪያ አሃድ ነው። ",
      "milkHeader": "ወተት (MK): ",
      "milkDef": "የMK EPD የሚለካው በእናቱ የማጥባት ችሎታ ምክንያት በክብደት ኪሎግራም ጥጃ ጡት በማጥባት ነው።",
      "totalMaternalHeader": "ጠቅላላ እናት(TM)፡ ",
      "totalMaternalDef": "TM በሁለቱም ወተት ምርት እና በላም ዘረመል ለእድገት ምክንያት በጥጃ ጡት ጡት ክብደት ላይ ያለውን ተጽእኖ ይለካል።",
      "calvingEaseDirectHeader": "የመጥፎ ቅለት ቀጥታ (ሲኢዲ)፦ ",
      "calvingEaseDirectDef": "CED EPD ያልተረዱ ጥጆች በመቶኛ ተዘርዝሯል።",
      "calvingEaseMaternalHeader": "የመውለድ ምቾት እናት (ሲኢኤም)፦ ",
      "calvingEaseMaternalDef": "የበሬ ሴት ልጆች የሁለት ዓመት ልጅ ሆነው ሳይረዱ ጥጃ የመውለድ አቅም ይለካል።",
      "stayabilityHeader": "የመቆየት (መቆየት)፦ ",
      "stayabilityDef": "የ ST EPD በሬ “በዙሪያው የሚቆዩ” ላሞችን የማሳም ችሎታ ይተነብያል። ",
      "docilityHeader": "ሰነድ (DOC)፦ ",
      "docilityDef": "DOC የከብቶቹን ባህሪ ይለካል.",
      "max": "ማክስ",
      "min": "ደቂቃ",
      "accuracy": "ትክክለኛነት",
      "sortBy": "ቅደምተከተሉ የተስተካከለው",
      "traits": "በግራጫ ቀለም የሚታዩ ባህሪያት በመገንባት ላይ ናቸው፣ በQ2፣ 2023 ይመጣሉ።",
      "searchResults": "የፍለጋ ውጤቶች",
      "recordsFound": "መዝገቦች ተገኝተዋል",
      "compareSelected": "የተመረጡትን አወዳድር",
      "animalIdentification": "የእንስሳት መለያ",
      "errorMessage": {
        "birthWeight": "የልደት ክብደት ከፍተኛው እሴት ከወሊድ ክብደት ዝቅተኛ መሆን አይችልም።",
        "weaningWeight": "የጡት ማጥባት ክብደት ከፍተኛው እሴት ከጡት ማጥባት ዝቅተኛ ክብደት ያነሰ ሊሆን አይችልም።",
        "yearlingWeight": "አመታዊ ክብደት ከፍተኛው እሴት ከአመት ክብደት ዝቅተኛ መሆን አይችልም።",
        "carcassWeight": "የሬሳ ክብደት ከፍተኛው እሴት ከወሊድ ክብደት ዝቅተኛ መሆን አይችልም።",
        "fatThickness": "የስብ ውፍረት ከፍተኛ ዋጋ ከጡት ማጥባት ዝቅተኛ ክብደት ያነሰ ሊሆን አይችልም።",
        "marbling": "ማርሊንግ ከፍተኛው እሴት ከአመት ክብደት ዝቅተኛ መሆን አይችልም።",
        "ribeyeArea": "የሪቤዬ አካባቢ ከፍተኛ ዋጋ ከወሊድ ክብደት ዝቅተኛ መሆን አይችልም።",
        "yieldGrade": "የምርት ውጤት ከፍተኛው እሴት ከጡት ማጥባት ዝቅተኛ ክብደት ያነሰ ሊሆን አይችልም።",
        "milk": "ከፍተኛው የወተት እሴት ከጡት ማጥባት ክብደት ያነሰ ሊሆን አይችልም።"
      },
      "reg": "ሬጅ",
      "name": "ስም",
      "sex": "ወሲብ",
      "tattoo": "ንቅሳት",
      "dob": "DOB",
      "EPD": "ኢ.ፒ.ዲ",
      "rank": "ደረጃ",
      "searchValue": "የፍለጋ እሴት",
      "typeHere": "እዚህ ይተይቡ",
      "searching": "በመፈለግ ላይ...",
      "fetchingResult": "ውጤቶችን በማምጣት ላይ...እባክዎ ይጠብቁ",
      "animalsMatchedYourCriteria": "እንስሳት ከመመዘኛዎችዎ ጋር ይጣጣማሉ",
      "manageAnimalsGrouping": "የእንስሳት መቧደንን አስተዳድር",
      "manageAnimalGroupings": "የእንስሳት ቡድኖችን ያቀናብሩ",
      "assignAnimalToContemporaryGroups": "እንስሳትን ለዘመናዊ ቡድኖች መድብ",
      "resetMode": "ሁነታን ዳግም አስጀምር",
      "enterResetMode": "ዳግም ማስጀመሪያ ሁነታን አስገባ",
      "maintainanceMode": "የጥገና ሁነታ",
      "assigningAnimals": "እንስሳትን መመደብ",
      "excludedAnimals": "የማይካተቱ እንስሳት",
      "ungroupedAnimals": "ያልተሰበሰቡ እንስሳት",
      "assignAnimalsToCGS": "እንስሳትን ለCGS መድብ",
      "reset": "ዳግም አስጀምር",
      "excludeAnimals": "እንስሳትን ማግለል",
      "resetToMaintainanceMode": "ዳግም ማስጀመር ተጠናቅቋል - ወደ ጥገና ሁነታ ቀይር",
      "contemporaryGroupsSettings": "የዘመናዊ ቡድኖች(CG) ቅንብሮች",
      "selectTrait": "ባህሪ ይምረጡ",
      "selectTraitDescription": "ባህሪን ይምረጡ አንድ የተወሰነ ባህሪን የመምረጥ ሂደትን ያመለክታል",
      "traitsType": {
        "birthWeight": "የልደት ክብደት",
        "weaningWeight": "የጡት ማጥባት ክብደት",
        "yearlingWeight": "አመታዊ ክብደት",
        "carcassWeight": "የሬሳ ክብደት"
      },
      "addNewGroup": "አዲስ ቡድን ጨምር",
      "contemporaryGroup": "ዘመናዊ ቡድን",
      "contemporaryGroups": "ዘመናዊ ቡድኖች",
      "editGroup": "ቡድን አርትዕ",
      "birthCGCode": "የልደት (CG) ኮድ",
      "groupName": "የቡድን ስም",
      "birthSex": "የወሊድ ወሲብ",
      "conceptionMethod": "የፅንሰ-ሀሳብ ዘዴ",
      "weaningCGCode": "የጡት ማጥባት (CG) ኮድ",
      "yearlingCGCode": "አመታዊ (CG) ኮድ",
      "dateWeight": "የቀን ክብደት",
      "weaningyearlingCGcode": "የጡት ማጥባት/አመት ልጅ (CG) ኮድ",
      "carcassCGCode": "የሬሳ (CG) ኮድ",
      "breedOfDom": "ግድብ ዘር",
      "addNewContemporaryGroup": "አዲስ ዘመናዊ ቡድን ያክሉ",
      "createNewGroup": "አዲስ ቡድን ይፍጠሩ",
      "selectFromDifferentTraits": "ከተለያዩ ባህሪያት ይምረጡ",
      "contemporaryGroupName": "የዘመናዊ ቡድን ስም",
      "enterNameHere": "ስም እዚህ ያስገቡ",
      "groupNameIsRequired": "የቡድን ስም ያስፈልጋል",
      "birthYearRange": "የልደት ዓመት ክልል",
      "theYearAnimalWasBorn": "ዓመት እንስሳ ተወለደ",
      "birthYearIsRequired": "የልደት ዓመት ያስፈልጋል",
      "genderOfNewBornAnimal": "አዲስ የተወለደ እንስሳ ጾታ",
      "selectSex": "ወሲብን ይምረጡ",
      "theweightOfAnimalAtBirth": "ሲወለድ የእንስሳት ክብደት",
      "maximumKg": "ከፍተኛ",
      "minimumKg": "ዝቅተኛ",
      "aSeasonisAPeriodOfYear": "ወቅት በልዩ የአየር ንብረት ሁኔታዎች የሚለይ የዓመት ወቅት ነው።",
      "seasonofBirthIsRequired": "የትውልድ ወቅት ያስፈልጋል",
      "majorGenericContributionOfAnimal": "ዋና % አጠቃላይ የእንስሳት መዋጮ",
      "primaryBreedCompostionIsRequired": "የመጀመሪያ ደረጃ ማዳበሪያ ያስፈልጋል",
      "secondaryBreedCompostionIsRequired": "ሁለተኛ ደረጃ የዝርያ ማዳበሪያ ያስፈልጋል",
      "howTheAnimalWasConceived": "እንስሳው እንዴት እንደተፀነሰ (ተፈጥሮአዊ ጋብቻ/ማዳቀል/የፅንስ ሽግግር)",
      "conceptionMethodIsRequired": "የፅንሰ-ሀሳብ ዘዴ ያስፈልጋል",
      "epdModelSettings": "የ EPD ሞዴል ቅንጅቶች",
      "forResetMode": "ለዳግም ማስጀመሪያ ሁነታ",
      "progenyWeightingFactor": "የትውልድ ክብደት ምክንያት",
      "weightGivenToTheProgenyFactor": "በዳግም ማስጀመሪያ ሁነታ ለኤፒዲ ስሌት ከCG factor አንጻር ለትውልድ የሚሰጠው ክብደት። ",
      "enterNumber": "ቁጥር አስገባ",
      "enterBreed": "ዘር አስገባ",
      "valueShouldBeBetween0and1": "ዋጋ በ0 እና 1 መካከል መሆን አለበት።",
      "resetDuration": "የሚቆይበትን ጊዜ ዳግም ያስጀምሩ",
      "timeIntervalBetweenLastAndFirstResetMode": "በመጨረሻው እና በአዲሱ ዳግም ማስጀመሪያ ሁነታ መካከል ያለው የጊዜ ክፍተት፣ በዚህ ጊዜ መጨረሻ ላይ አዲሱ ዳግም ማስጀመር ሁነታ የነቃ እና አዲስ ሲጂ እና ኢፒዲዎች ይሰላሉ።",
      "enterNumberOfDays": "የቀኖችን ቁጥር ያስገቡ",
      "valueCannotBeNegative": "ዋጋ አሉታዊ ሊሆን አይችልም!",
      "criticalProgenyPopulation": "ወሳኝ የትውልድ ህዝብ",
      "minimumNumberOfProgenyRecords": "የፕሮጀኒ ትክክለኛነትን (APD1) ከ 50% በላይ (ለዘር ትክክለኝነት) ለማሳካት በስርአቱ ውስጥ ያለው የግለሰብ እንስሳ ዝቅተኛ የትውልድ መዛግብት",
      "criticalAncestorPopulation": "ወሳኝ ቅድመ አያቶች የህዝብ ብዛት",
      "minimumNumberOfAncestorsRecords": "Ancestor Accuracy (APD4) ከ50% በላይ (ለዘር ትክክለኝነት) በሥርዓተ-ሥርዓት ውስጥ ያለው የነፍስ ወከፍ እንስሳ ዝቅተኛው የአያቶች መዛግብት",
      "forBirthWeightCG": "ለልደት ክብደት CG",
      "criticalPopulationInAnimalsContemporaryGroup": "በእንስሳት ዘመናዊ ቡድን ውስጥ ወሳኝ የህዝብ ብዛት",
      "minimumAverageNumberOfAnimalsPerBirthWeight": "አማካይ የሲጂ ትክክለኛነት (ACG3) ከ 50% በላይ ለማግኘት በወሊድ ክብደት CG አስፈላጊ የሆኑ አነስተኛ አማካይ የእንስሳት ብዛት",
      "criticalAveragePopulationPerContemporaryGroup": "ወሳኝ አማካይ የህዝብ ብዛት በዘመናዊ ቡድን",
      "minimumNumberOfAnimalsInBirthWeight": "የ CG ትክክለኛነትን (ACG2) ከ 50% በላይ ለማግኘት በእንስሳው ልደት ክብደት CG ውስጥ ያሉ አነስተኛ የእንስሳት ብዛት",
      "forWeaningWeightCG": "ለጡት ማጥባት ክብደት CG",
      "minimumAverageNumberOfAnimalsPerWeaningWeight": "አማካኝ የሲጂ ትክክለኛነትን (ACG3) ከ50% በላይ ለማሳካት በእያንዳንዱ ጡት በማጥባት ክብደት CG አስፈላጊ የሆነው ዝቅተኛ አማካይ የእንስሳት ብዛት።",
      "minimumNumberOfAnimalsInWeaningWeight": "በእንስሳቱ የጡት ማጥባት ክብደት CG ውስጥ የ CG ትክክለኛነትን (ACG2) ከ 50% በላይ ለማግኘት አስፈላጊ የሆኑት አነስተኛ የእንስሳት ብዛት",
      "forYearlingWeightCG": "ለዓመት ክብደት CG",
      "minimumAverageNumberOfAnimalsPerYearling": "አማካኝ የሲጂ ትክክለኛነትን (ACG3) ከ50% በላይ ለማሳካት በዓመት CG አስፈላጊ የሆኑ አነስተኛ አማካይ የእንስሳት ብዛት።",
      "minimumNumberOfAnimalsInYearlingWeight": "የ CG ትክክለኛነትን (ACG2) ከ 50% በላይ ለማሳካት በእንስሳው አመታዊ ክብደት CG ውስጥ ያሉ አነስተኛ የእንስሳት ብዛት",
      "forCarcassCG": "ለሬሳ ሲጂ",
      "minimumAverageNumberOfAnimalsPerCarcassWeight": "አማካኝ የሲጂ ትክክለኛነትን (ACG3) ከ50% በላይ ለማሳካት በእያንዳንዱ ሥጋ ክብደት CG አስፈላጊ የሆኑ አነስተኛ አማካይ የእንስሳት ብዛት።",
      "minimumNumberOFAnimalInCarcassWeight": "የ CG ትክክለኛነትን (ACG2) ከ 50% በላይ ለማግኘት በእንስሳው አስከሬን ክብደት CG ውስጥ ያሉ አነስተኛ የእንስሳት ብዛት",
      "epdRequiredFieldSettings": "EPD የሚፈለጉ የመስክ ቅንብሮች",
      "pleaseSelectRequiredFieldsForCompleteEPD": "እባክዎ ለተሟላ EPD ስሌት የሚያስፈልጉትን መስኮች ይምረጡ",
      "byDefault": "በነባሪ",
      "pleaseNoteThatUsersNotAbleToObtainFullEPD": "ማስታወሻ፡ ተጠቃሚዎች እንደ አስፈላጊነቱ ምልክት ያደረጉባቸውን የመረጃ መስኮች ካላቀረቡ ሙሉ የEPD ስሌት ማግኘት እንደማይችሉ እባክዎ ልብ ይበሉ።",
      "pleaseNoteThatRequiredFieldParametersCannotBeChanged": "ማሳሰቢያ፡ እባክዎ ከቀደምት ግቤቶች ጋር የሚቃረኑ የዘመኑ ቡድኖች ስላሉ አስፈላጊ የመስክ መለኪያዎች ሊለወጡ እንደማይችሉ ልብ ይበሉ።",
      "noResultFound": "ምንም ውጤት አልተገኘም።",
      "next": "ቀጥሎ",
      "cancel": "ሰርዝ",
      "selectAnimal": "እንስሳ ይምረጡ",
      "searchBy": "ፍለጋ በ",
      "breed": "ዘር",
      "regDate": "ሬጅ. ",
      "status": "ሁኔታ",
      "animalDetails": "የእንስሳት ዝርዝሮች",
      "add": "አክል",
      "update": "አዘምን",
      "dataForEPDs": " የEPDዎች ውሂብ",
      "basicInformation": "መሰረታዊ መረጃ",
      "birthWeightInformation": "የልደት ክብደት መረጃ",
      "weaningWeightInformation": "የጡት ማጥባት ክብደት መረጃ",
      "yearlingWeightInformation": "አመታዊ ክብደት መረጃ",
      "carcassWeightInformation": "የካርኬጅ ክብደት መረጃ",
      "delete": "ሰርዝ",
      "deleteEpdData": "የ EPD ውሂብን ሰርዝ",
      "areYouSureYouWantToDeleteEpdData": "እርግጠኛ ነዎት የEPD ውሂብን መሰረዝ ይፈልጋሉ።",
      "internationalID": "ዓለም አቀፍ መታወቂያ",
      "enterID": "መታወቂያ አስገባ",
      "animalRegistration": "የእንስሳት ምዝገባ",
      "location": "አካባቢ",
      "additionalIDMethod": "ተጨማሪ መታወቂያ ዘዴ",
      "damID": "ግድብ መታወቂያ",
      "sireID": "የሲር መታወቂያ",
      "breederHerdCode": "የእርባታ መንጋ ኮድ",
      "birthYear": "የትውልድ አመት",
      "primaryBreed": "የመጀመሪያ ደረጃ ዝርያ",
      "breedComposition": "የዘር ቅንብር",
      "secondaryBreed": "ሁለተኛ ደረጃ ዝርያ",
      "seasonofBirth": "የትውልድ ወቅት",
      "birthManagementCode": "የወሊድ አስተዳደር ኮድ",
      "damAge": "ግድብ ዘመን",
      "years": "ዓመታት",
      "birthContemporaryCode": "የዘመናዊ ልደት ኮድ",
      "accuracyWeight": "ትክክለኛ ክብደት",
      "note": "ማስታወሻ",
      "minimumRequiredFieldForBirthWeight": "ለልደት ክብደት EPDs የሚፈለገው ዝቅተኛው መስክ",
      "birthYearGenderConceptionMethodBirthWeight": "የልደት ዓመት , ጾታ , የመፀነስ ዘዴ , የልደት ክብደት",
      "weaningWeight": "የጡት ማጥባት ክብደት",
      "weaningDate": "የጡት ማጥባት ቀን",
      "weaningContemporaryGroupCode": "የጡት ማጥባት ኮንቴምፖራሪ ቡድን ኮድ",
      "creep": "ሸርተቴ",
      "managementPastureCode": "አስተዳደር / የግጦሽ ኮድ",
      "weaningSex": "ጡት ማጥባት ወሲብ",
      "minimumRequiredFieldForWeaningWeight": "ለጡት ማጥባት ክብደት EPDs የሚፈለገው ዝቅተኛው መስክ",
      "weaningWeightManagementPastureCodeWeaningSexDateWeighed": "የጡት ማጥባት ክብደት , አስተዳደር / የግጦሽ ኮድ , ጡት ጡት ወሲብ , የተመዘነበት ቀን",
      "yearlingWeight": "አመታዊ ክብደት",
      "yearlingHeight": "አመታዊ ቁመት",
      "yearlingDate": "አመታዊ ቀን",
      "yearlingContemporaryGroupCode": "አመታዊ የዘመናዊ ቡድን ኮድ",
      "managementFeedingCode": "የአስተዳደር / የመመገቢያ ኮድ",
      "yearlingSex": "አመታዊ ወሲብ",
      "youWillNeedToFillOutFor": "ለ EPD ውሂብ ለማምጣት ሁሉንም መስኮች መሙላት ያስፈልግዎታል",
      "pleaseSelectHavestDateFirstToEnterInfo": "እባክዎ ለርብ አይን አካባቢ፣የስብ ውፍረት እና ማርሊንግ መረጃ ለማስገባት መጀመሪያ 'የመከር ቀን' የሚለውን ይምረጡ።",
      "harvestDate": "የመከር ቀን",
      "dateOnFeed": "በምግብ ላይ ያለ ቀን",
      "daysOnFeed": "በምግብ ላይ ያሉ ቀናት",
      "gradingDate": "የደረጃ አሰጣጥ ቀን",
      "carcassSex": "ሥጋ ወሲብ",
      "carcassWeight": "የሬሳ ክብደት",
      "carcassContemporary": "የሬሳ ኮንቴምፖራሪ",
      "damBreed": "ግድብ ዘር",
      "ribEyeArea": "የጎድን አጥንት አካባቢ",
      "ribEyeAreaContemporary": "የርብ አይን አካባቢ ዘመናዊ",
      "fatThickness": "ወፍራም ውፍረት",
      "fatThicknessContemporary": "የስብ ውፍረት ዘመናዊ",
      "marbling": "ማርሊንግ",
      "marblingContemporary": "ማርሊንግ ኮንቴምፖራሪ",
      "yieldGradeContemporary": "የዘመናዊ ምርት ውጤት",
      "animalsNotListedInContemporaryGroupsMsg": "በጠፋ መረጃ ምክንያት እንስሳት ወደ የትኛውም ወቅታዊ ቡድኖች አልተጨመሩም። ",
      "listOfUngroupedAnimals": "ያልተሰባሰቡ እንስሳት ዝርዝር",
      "submittingData": "ውሂብ በማስረከብ ላይ",
      "resendToUser": "እንደገና ለተጠቃሚ ላክ",
      "submittingAnimalsInGroupMsg": "እንስሳትዎን በቡድን በማስረከብ ላይ። ",
      "pressingResetBtnMsg": "የ \"ዳግም አስጀምር\" ቁልፍን መጫን እንስሳትን ወደ ወቅታዊ ቡድኖቻቸው የመመደብ ሂደት ይጀምራል።",
      "doYouWantToProceed": "መቀጠል ይፈልጋሉ?",
      "systemMaintainanceModeMsg": "\"ወደ ጥገና ሁነታ ቀይር\" ቁልፍን መጫን ሂደቱን ይጀምራል እና ስርዓትዎ ወደ \"የጥገና ሁነታ\" ይገባል በዳግም ማስጀመሪያው ላይ የሚሰሉት ኢዲፒዎች ለእያንዳንዱ እንስሳ እስከሚቀጥለው ዳግም አስጀምር ድረስ ይጠበቃሉ (ይህም ከ1-6 ወራት ሊሆን ይችላል) ",
      "errorFetchingContemporaryGrpMsg": "የዘመናዊ ቡድን ውሂብ ማምጣት ላይ ስህተት",
      "deleteSuccess": "ስኬትን ሰርዝ",
      "deleteSuccessMsg": "የዘመኑ ቡድን በተሳካ ሁኔታ ተሰርዟል።",
      "deleteFailed": "መሰረዝ አልተሳካም።",
      "deleteFailedMsg": "የዘመኑን የቡድን ውሂብ መሰረዝ ላይ ስህተት",
      "deleteContemporaryGrpMsg": "እርግጠኛ ነዎት ይህን ወቅታዊ ቡድን መሰረዝ ይፈልጋሉ?",
      "addBirthWeightData": "የልደት ክብደት ውሂብ ያክሉ",
      "addWeaningWeightData": "የጡት ማጥባት ክብደት ውሂብን ይጨምሩ",
      "birthWeightContemporaryGroupCode": "የልደት ክብደት ኮንቴምፖራሪ ቡድን ኮድ",
      "dateWeighted": "የተመዘነበት ቀን",
      "addYearlingWeightData": "አመታዊ የክብደት ውሂብን ያክሉ",
      "addCarcassWeightData": "የካርኬጅ ክብደት ውሂብን ያክሉ",
      "weaningOrYearlingContemporaryGroupCode": "ጡት ወይም አመታዊ ክብደት ወቅታዊ የቡድን ኮድ",
      "deleteContemporaryGroupMsg": "እርግጠኛ ነህ የዘመኑን ቡድን መሰረዝ ትፈልጋለህ?",
      "updateSuccessMsg": "የዘመኑ ቡድን በተሳካ ሁኔታ ዘምኗል።",
      "errorMsg": "የሆነ ስህተት ተከስቷል. ",
      "fetchErrorMsg": "ለተመረጠው ባህሪ የሚያስፈልጉ መስኮችን ማምጣት ላይ ስህተት።",
      "forMaintainanceMode": "ለጥገና ሁነታ",
      "ancestorsWeightFactor": "ቅድመ አያቶች ክብደት ምክንያት",
      "weightGivenToTheAncestorFactor": "በጥገና ሁነታ ለ EPD ስሌት ከሲጂ ፋክተር አንጻር ለአያት ቅድመ ሁኔታ የተሰጠ ክብደት። ",
      "addEPDModelSettingsData": "የEPD ሞዴል ቅንብሮች ውሂብ ያክሉ",
      "minimumNumberOfAnimalsInContemporaryGroups": "በዘመናዊ ቡድኖች ውስጥ አነስተኛ የእንስሳት ብዛት",
      "enterNumberOfAnimals": "የእንስሳትን ቁጥር አስገባ",
      "areYouSureYouWantToChangeEPDCalculation": "እርግጠኛ ነዎት አስፈላጊዎቹን የEPD ስሌት መስኮች መቀየር ይፈልጋሉ?",
      "weightOfAnimalAtBirth": "በወሊድ ጊዜ የእንስሳት ክብደት",
      "seasonIsAPeriodOfYear": "ወቅት በልዩ የአየር ንብረት ሁኔታዎች የሚለይ የዓመቱ ወቅት ነው።",
      "codeOfBirthWeightContemporaryGroup": "የልደት ክብደት ኮንቴምፖራሪ ቡድን ኮድ",
      "weaningWeightOfCalf": "የጥጃ ጡት ማጥባት ክብደት",
      "dateAnimalWasWeaned": "እንስሳው ጡት የተጣለበት ቀን",
      "genderOfWeaningAnimal": "የጡት ማጥባት እንስሳ ጾታ",
      "yearlingWeightOfCalf": "የዓመት ጥጃ ክብደት",
      "dateAnimalWasWeighted": "እንስሳው የተመዘነበት ቀን",
      "yearledAnimalSex": "የዓመት ዓመት የሆነው የእንስሳት ጾታ",
      "dateOfAnimalKilledForMeat": "ለስጋ የተገደለ እንስሳ ቀን",
      "addSuccessMsg": "የዘመኑ ቡድን በተሳካ ሁኔታ ታክሏል።",
      "traitH": "ለ EPD ስሌት ባህሪ.",
      "searchByValue": "የምዝገባ ቁጥር/ንቅሳት/ስም/መለያ አስገባ"
    }
  }